import React, {useRef, useMemo,useEffect, useState} from "react";
import {
    Modal,
    Callout,
    Checkbox,
    Dropdown,
    IDropdown,
    IconButton,
    TooltipHost,
    ThemeProvider,
    PrimaryButton,
    ScrollablePane,
    ContextualMenu,
    IObjectWithKey,
    DirectionalHint,
    IDropdownOption,
    IContextualMenuItem,
    ScrollbarVisibility,
    IDetailsHeaderProps,
    ShimmeredDetailsList
} from "@fluentui/react";
import debounce from "lodash/debounce";


import {
    IColumn,
    Selection,
    DetailsRow,
    DetailsList,
    SelectionMode,
    IDetailsRowProps,
    IDetailsColumnProps,
    DetailsListLayoutMode
} from "@fluentui/react/lib/DetailsList";

import Select from "react-select";

import ButtonHold from "../ButtonHold/ButtonHold";
import ThumbnailImage from "./ThumbnailImage";
import { rehydrateKeyToDate, parseRehydrateKeyToMs, smoothScrollLeft } from "./../../util_more";
import { toast } from "react-toastify";
import { Fabric } from "@fluentui/react/lib/Fabric";
import { TextField } from "@fluentui/react/lib/TextField";
import { MarqueeSelection } from "@fluentui/react/lib/MarqueeSelection";

import { ImBin } from "react-icons/im";
import { CgWebsite } from "react-icons/cg";
import { TbTableDown } from "react-icons/tb";
import { FaWindowClose } from "react-icons/fa";
import { RiShiningLine } from "react-icons/ri";
import { RxDragHandleDots2 } from "react-icons/rx";
import { FiEdit, FiYoutube, FiFilter, FiDownload, FiDatabase, FiTrash2, FiStar, FiSave, FiCheck, FiPlus } from "react-icons/fi";
import { BiChevronDown, BiMessageSquareDetail } from "react-icons/bi";
import { LuMailQuestion, LuColumns3 } from "react-icons/lu";
import { BiColumns } from "react-icons/bi";


import { AddURLs } from "../../components/AddURLs";
import UploadCards from "../../components/UploadCards/UploadCards";
import RollingStatus from "../../components/RollingStatus/RollingStatus";
import JsonGridInvoice from "../../components/JsonGridInvoice/JsonGridInvoice";
import AISearchJsonGrid from "../../components/AISearchJsonGrid/AISearchJsonGrid";

import JsonListTable from "../../components/JsonListTable/JsonListTable";

import { CalendarDateTime } from "@internationalized/date";
import CollapsibleSections from "../../components/CollapsibleSections/CollapsibleSections";
import ChartRendererAnalysis from "../../components/ChartRenderer/ChartRendererAnalysis";
import ConversationRecognizer from "../../components/SpeechRecognizer/ConversationRecognizer";

import {
    getAiDiff,
    reprocessDocs,
    deleteFile,
    downloadPDF,
    ai_comparison,
    qJsonAnalysis,
    dataExtractionApi,
    qJsonAnalysisRemove,
    qJsonAnalysisRecall,
    reRunPreconfAnalysis,
    publishTranscriptDraft,
    qUpdateFieldOrder,
    qApplyFieldOrderByDocType,
    qUpdateAiContent,
} from "../../api";
import { getBaseAiData, qUpdateBaseContent, qGetVersions, qGetVersionData, downloadVersionFile, qGetListViews, qSaveListView, qDelListView, qSetDefaultView } from "../../api/qpi";

import { greindexparams, gtranscriptpublish, gdiffresponse, gfile, gfanalyse, gversionrow, glistview, gviewpayload, IDocument } from "../../interfaces";
import {
    assistantCodes,
    helpMailTooltip,
    dpaAnalysisOpt2Keys,
    localStorageMainListSorting,
    detailsListContentTypeOptions,
    dpaAnalysisOptionsDisplayNames,
    noVisibilityChangeCols,
    valueFilterableCols,
    keyToFileProp
} from "../../lsts";


import {
    thStylesDetList1,
    thStylesDetList2,
    detailsListTheme,
    tooltipHostStyles,
    scrollablePaneStyles,
    listContextMenuStyles,
    modalAIAnalysisStyles,
    analysisOptionsStyles,
    tooltipListThumbStyles,
    analysisCloseButStyles,
    analysisRemoveButStyles,
    dropdownDetailsListStyles,
    textFieldStylesMultiAIAnalyseOpt,
    scrollablePaneShortStyles,
    visibilityCalloutContentStyles,
} from "../../styles_glob";
import {
    onSTT,
    prepHtml,
    getByPath,
    get_mod_str,
    getLocalSortState,
    removeUnderscoreAndCapitalize,
    setLocalSortState,
    getContentPathWithId,
    getDateToDisplay,
    isArrNonempty,
    rewrapUcpData
} from "../../util_glob";
import {
    pdfI,
    mainSort,
    getHeader,
    exportCSV,
    exportInvDataCSV,
    classNames,
    isItemReady,
    parseDocuments,
    onUploadCardClick,
    includesTextNested,
    invoiceValidColumn,
    getStatusColorClass,
    getTypeTooltipContent,
    onRenderDetailsHeader,
    analyseInfotipAnalyse,
    exportAIExtractPredef,
    onRenderDetailsHeaderV2,
    vertikalScrollKey,
    horizontalScrollKey,
    controlDetailsListMainStyles,
    controlDetailsListMainStylesV2,
    formatDateTimeClientTimeZone,
    IDetailsListDocumentsExampleState,
    IDetailsListDocumentsExampleProps,
    _onLoadSort,
    _copyAndSort,
    _copyAndSortAdv,
    _copyAndSortInvStr,
    _copyAndSortAdvTotal,
    hidePdfExt_dash
} from "./detailedMdls";
import SrchBox from "./srchBox";
import DashListSidebar_dash from "./DashListSidebar_dash";
import styles from "./detailedList.module.css";
import { AiOutlineReload } from "react-icons/ai";
import JsonViewerInteractive from "../JsonGridGen/JsonViewerInteractive";
import smoothScrollIntoView from "smooth-scroll-into-view-if-needed";
import ButtonHoldCircular from "../ButtonHoldCircular/ButtonHoldCircular";

// 🧩 saved column views cached per group for the browser session (cleared on refresh).
// Holds the fetched views so we don't re-pull when switching back to a group, until the
// user updates/creates a view (which repopulates the entry).
const listViewsSessionCache: Record<string, glistview[]> = {};

export class DetailsListDocumentsExample extends React.Component<IDetailsListDocumentsExampleProps, IDetailsListDocumentsExampleState> {
    public _selection: Selection;

    private _allItems: IDocument[];

    private resizeObserver?: ResizeObserver;

    private resizeTimeout?: number;

    private restoreScrollTimeout?: number;

    private scrollContainer?: HTMLElement;

    private savedScrollPosition: number = 0;

    private savedScrollLeft: number = 0;

    private contextMenuColumnKey?: string;

    private versionFileClickGuard: boolean = false;   // 🕰️ suppress row-activate when a version file link is clicked

    private filterRunSeq: number = 0;

    private filterInputDebounced = debounce((text?: string) => {
        void this.runFilterAsync(text);
    }, 220);

    constructor(props: IDetailsListDocumentsExampleProps) {
        super(props);

        this._allItems     = parseDocuments(this.props.fileList || [], this.props.selectedGroup.oid);

        const hasTagCols   = this._allItems.filter(item => item?.tag || "" != "").length > 0;
        const hasUrlCols   = this.props?.fileList && this.props.selectedGroup.assistanttype != assistantCodes.ipa && this.props?.fileList?.some(item => item?.file_url && item.file_url !== "")
        const hasAudioRecs = this.props.selectedGroup.allowaudiodocentry == 1 || this.props.selectedGroup.allowaudiofiles;
        const isMobile     = window.matchMedia("(pointer: coarse)").matches;

        // main column schema
        const columns: IColumn[] = [
            // file type
            ...(this.props.selectedGroup.assistanttype != assistantCodes.ipa
                ?   [
                        {
                            key: "kgnf_filetype",
                            name: "File Type",
                            className: classNames.fileIconCell,
                            iconClassName: classNames.fileIconHeaderIcon,
                            ariaLabel: "Press to sort on File type",
                            iconName: "Page",
                            isCollapsible: true,
                            isIconOnly: true,
                            fieldName: "name",
                            minWidth: 16,
                            maxWidth: 16,
                            isPadded: false,
                            onColumnClick: this._onColumnClick,
                            onRender: (item: IDocument) => {return item.sourcetype == "youtube" ? <FiYoutube /> : item.sourcetype == "web" ? <CgWebsite /> : pdfI}
                        }
                    ]
                : []),
            { // id
                key: "kgnf_key",
                name: "Id",
                isCollapsible: false,
                fieldName: "key",
                className: classNames.cellAlignment,
                minWidth: 25,
                maxWidth: 25,
                isResizable: true,
                onColumnClick: this._onColumnClick,
                data: "number",
                isPadded: false,
                onRender: (item: IDocument) => {return <div className={styles.colKey} data-cval={item.key}>{item.key}</div>}

            },
            { // name
                key: "kgnf_name",
                name: "Name",
                fieldName: "displayName",
                minWidth: 150,
                className: classNames.cellAlignment,
                currentWidth:300,
                maxWidth: 800,
                isRowHeader: true,
                isResizable: true,
                isSorted: true,
                isSortedDescending: false,
                sortAscendingAriaLabel: "Sorted A to Z",
                sortDescendingAriaLabel: "Sorted Z to A",
                onColumnClick: this._onColumnClick,
                data: "string",
                isPadded: false,
                onRender: (item: IDocument) => {
                    const [isLoaded, setIsLoaded] = useState(false);
                    return (
                        (item.doc_category != 'data' && isItemReady(item) == true) ?(
                            <TooltipHost
                                onTooltipToggle={(isVisible) => {if (isVisible && !isLoaded && isItemReady(item) == true) setIsLoaded(true)}}
                                directionalHint={DirectionalHint.rightBottomEdge}
                                className={styles.toolThumb}
                                key={`listIT${item.key}`}
                                styles={tooltipListThumbStyles}
                                closeDelay={300}
                                content={ (isMobile != true && item.doc_category != 'data') ? <ThumbnailImage item={item} companyId={this.props.selectedGroup.companyid} show={isLoaded} /> : <div/>}
                            >
                                <div data-cval={item.name} className={styles.colName} onClick={() => this.handleDocumentDisplay(item)}>
                                    {hidePdfExt_dash(item.name)}
                                </div>
                            </TooltipHost>
                        ) : (
                            <div data-cval={item.name} className={styles.colName} onClick={() => this.handleDocumentDisplay(item)}>
                                {hidePdfExt_dash(item.name)}
                            </div>
                        )
                    );
                }
            },
            { // more options
                key: "kgnf_path",
                name: "",
                minWidth: 20,
                maxWidth: 20,
                isResizable: false,
                isIconOnly: true,
                isPadded: false,
                onRender: (item: IDocument) => (
                    <div className={styles.moreIconBut}>
                        <IconButton
                            className={styles.moreIconIn}
                            iconProps={{ iconName: "MoreVertical" }}
                            styles   ={{ root: { height: "100%", padding: "5px", borderRadius: "4px" } }}
                            data-cval={''}
                            onClick  ={(e: React.MouseEvent<HTMLElement>) => {
                                e.stopPropagation();
                                const domEvent = e.nativeEvent;
                                this.onItemContextMenu(item, 0, domEvent);
                            }}
                        />
                    </div>
                )
            },
            ...(this.props.selectedGroup.assistanttype == "dpa" ?
            [
                {   // dpa analysis
                    key: "analysis",
                    name: "✨",
                    fieldName: "ai",
                    minWidth: 30,
                    maxWidth: 530,
                    isPadded: false,
                    isResizable: true,
                    onRender: (item: IDocument) => {
                    return (
                        <div className={styles.intCellCont} data-cval={item?.aiinteractions?.join(', ') || ''}>
                            <TooltipHost
                                key={`aiiin${item.key}`}
                                content={isArrNonempty(item, 'aiinteractions') == true ? `AI Analysis Available` : analyseInfotipAnalyse()}
                                styles={tooltipHostStyles}
                                directionalHint={DirectionalHint.rightCenter}
                            >
                                {isArrNonempty(item, 'aiinteractions') == true ? (

                                    item?.aiinteractions?.map((interaction: any, index: number) => {
                                        return (
                                            <div
                                                key={`aii_${interaction}`}
                                                data-high-id={interaction}
                                                className={styles.aiinteractionstorage}
                                                onClick={() => {this.handleAIInteractionClick(interaction || "", item.doc_category || "", item?.fileid?.toString() || "")}}
                                                onMouseEnter={() => {
                                                    const matchId = interaction.toString();
                                                    Array.from(document.querySelectorAll<HTMLElement>(`.${styles.aiinteractionstorage}`))
                                                        .filter(el => el.dataset.highId?.includes(matchId))
                                                        .forEach(el => {
                                                            el.classList.add("aiInteractionHighlight");
                                                        });
                                                }}
                                                onMouseLeave={() => {
                                                    document
                                                        .querySelectorAll<HTMLElement>(".aiInteractionHighlight")
                                                        .forEach(el => el.classList.remove("aiInteractionHighlight"));
                                                }}
                                            >
                                                <BiMessageSquareDetail size={12} />
                                            </div>
                                        );
                                })
                                ) : (
                                    <div className={styles.analysisActionIcon} onClick={() => {this.handleAnalyseOptionsClick(this._selection.getSelection(), false)}}>
                                        <RiShiningLine size={12}  />
                                    </div>
                                )}
                            </TooltipHost>
                        </div>
                        );
                    }
                }
            ] : []),
            {   // modified
                key: "dateModifiedValue",
                name: "Modified",
                fieldName: "dateModifiedValue",
                minWidth: 90,
                currentWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isPadded: false,
                onColumnClick: this._onColumnClick,
                data: "number",
                // onRenderHeader: this._renderDateFilterHeader("dateModifiedValue", "Modified"),
                onRender: (item: IDocument) => {
                    return <div title={formatDateTimeClientTimeZone(item.dateModified)} className={styles.colMod} data-cval={formatDateTimeClientTimeZone(item.dateModified)}>{formatDateTimeClientTimeZone(item.dateModified)}</div>;
                }
            },
            ...(this.props.selectedGroup.assistanttype == assistantCodes.ipa ?
            [
                {   // inv invoice id
                    key: "kgnf_inv_id",
                    name: "Invoice Id",
                    fieldName: "invoicedataobj.invoice_id",
                    minWidth: 60,
                    isCollapsible: false,
                    currentWidth: 95,
                    maxWidth: 300,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: false,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.invoice_id")} data-cval={getByPath(item, "invoicedataobj.invoice_id")}>{getByPath(item, "invoicedataobj.invoice_id")}</div>
                },
                {   // inv customer column
                    key: "kgnf_customer",
                    name: "Customer",
                    fieldName: "invoicedataobj.customer_name",
                    minWidth: 120,
                    isCollapsible: false,
                    currentWidth: 95,
                    maxWidth: 300,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: false,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.customer_name")} data-cval={getByPath(item, "invoicedataobj.customer_name")}>{getByPath(item, "invoicedataobj.customer_name")}</div>
                },
                {   // inv contractor column
                    key: "kgnf_contractor",
                    name: "Contractor",
                    fieldName: "invoicedataobj.contractor_name",
                    minWidth: 120,
                    isCollapsible: false,
                    currentWidth: 95,
                    maxWidth: 300,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: false,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.contractor_name")} data-cval={getByPath(item, "invoicedataobj.contractor_name")}>{getByPath(item, "invoicedataobj.contractor_name")}</div>
                },
                {   // inv vat column
                    key: "kgnf_vat",
                    name: "Vat",
                    fieldName: "invoicedataobj.vat",
                    minWidth: 30,
                    maxWidth: 100,
                    currentWidth: 80,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: false,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.vat")} data-cval={getByPath(item, "invoicedataobj.vat")}>{getByPath(item, "invoicedataobj.vat")}</div>
                },
                {   // inv total column
                    key: "kgnf_total",
                    name: "Total",
                    fieldName: "invoicedataobj.invoice_total",
                    minWidth: 20,
                    maxWidth: 100,
                    currentWidth: 80,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: true,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.invoice_total")} data-cval={getByPath(item, "invoicedataobj.invoice_total")}>{getByPath(item, "invoicedataobj.invoice_total")}</div>
                },
                {   // inv valid column
                    key: "kgnf_valid",
                    name: "Valid",
                    fieldName: "invoicedataobj.kgnf_valid",
                    minWidth: 10,
                    maxWidth: 10,
                    isResizable: false,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: true,
                    onRender: (item: IDocument) =>
                        invoiceValidColumn(
                            item,
                            this.props.selectedGroup,
                            this.state.isWorkingOnDelete,
                            this.handleInvExtractClick,
                            this.handleDocumentDisplay
                        )
                },
                {   // inv date column
                    key: "kgnf_date",
                    name: "Date",
                    fieldName: "invoicedataobj.invoice_date",
                    minWidth: 30,
                    maxWidth: 30,
                    currentWidth: 30,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: true,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.invoice_date")} data-cval={getByPath(item, "invoicedataobj.invoice_date")}>{getByPath(item, "invoicedataobj.invoice_date")}</div>
                },
                {   // inv due date column
                    key: "due_date",
                    name: "Due Date",
                    fieldName: "invoicedataobj.payment_due_date",
                    minWidth: 40,
                    maxWidth: 30,
                    currentWidth: 30,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: true,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.payment_due_date")} data-cval={getByPath(item, "invoicedataobj.payment_due_date")}>{getByPath(item, "invoicedataobj.payment_due_date")}</div>
                },
                {   // inv due date column
                    key: "iban",
                    name: "IBAN",
                    fieldName: "invoicedataobj.iban",
                    minWidth: 40,
                    maxWidth: 40,
                    currentWidth: 40,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: true,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.iban")} data-cval={getByPath(item, "invoicedataobj.iban")}>{getByPath(item, "invoicedataobj.iban")}</div>
                },
                {   // inv contractor VAT identification column
                    key: "contractor_vat_identification",
                    name: "Cont. VAT",
                    fieldName: "invoicedataobj.contractor_vat_identification",
                    minWidth: 40,
                    maxWidth: 40,
                    currentWidth: 40,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    data: "string",
                    isPadded: true,
                    onRender: (item: IDocument) => <div className={styles.colInvType} title={getByPath(item, "invoicedataobj.contractor_vat_identification")} data-cval={getByPath(item, "invoicedataobj.contractor_vat_identification")}>{getByPath(item, "invoicedataobj.contractor_vat_identification")}</div>
                }
            ] : []),

            ...(this.props.selectedGroup.useapproval == 1 ?
            [
                {   // inv approval column
                    key: "approved",
                    name: "Confirmed",
                    fieldName: "approved",
                    minWidth: 68,
                    maxWidth: 68,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    onRenderHeader: this._renderValueFilterHeader("approved", "Confirmed"),
                    data: "string",
                    isPadded: false,
                    onRender: (item: IDocument) => {
                        return (
                            <div className={styles.confirmInvoiceButton} data-cval={item.approved == 1 ? "Confirmed" : "Not Confirmed"}>
                                <ButtonHold
                                    confirmed={item.approved == 1}
                                    confirm={() => {this.qApprove()}}
                                />
                            </div>
                        );
                    }
                }
            ] : []),
            ...(hasTagCols == true ?
            [
                {   // tag column
                    key: "kgnf_tag",
                    name: "Tag",
                    fieldName: "tag",
                    minWidth: 45,
                    currentWidth: 95,
                    maxWidth: 500,
                    isResizable: true,
                    isPadded: false,
                    onColumnClick: this._onColumnClick,
                    onRender: (item: IDocument) => {{return <div className={styles.colInvType} title={item.tag} data-cval={item.tag}>{item.tag}</div>}}
                }
            ] : []),
            ...(hasUrlCols == true ?
            [
                {  // file url column
                    key: "kgnf_fileurl",
                    name: "Link",
                    fieldName: "file_url",
                    minWidth: 100,
                    currentWidth: 200,
                    maxWidth: 500,
                    isResizable: true,
                    isPadded: false,
                    onColumnClick: this._onColumnClick,
                    onRender: (item: IDocument) => {
                        return (
                            <div className={styles.listColumnFileUrl} title={item?.file_url || item?.sourceurl} data-cval={item?.file_url || item?.sourceurl} onClick={() => {
                                window.open(item?.file_url || item?.sourceurl, "_blank");
                            }}>
                                <div>{item?.file_url || item?.sourceurl }</div>
                            </div>
                        );
                    }
                }
            ] : []),
            ...(hasAudioRecs == true ?
            [
                {   // audio edit column
                    key: "kgnf_edit",
                    name: "Edit",
                    fieldName: "editcntnt",
                    minWidth: 5,
                    maxWidth: 5,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    isPadded: true,
                    onRender: (item: IDocument) => {
                        const hasTranscriptions = (item?.transcription?.length || 0) > 0;
                        return (item?.transcription?.length || 0) > 0 ? (
                            <div onClick={() => {this.setState({ isMicModalVisible: true })}} style={{ marginTop: "2px", marginBottom: "-10px", cursor: "pointer" }} data-cval={hasTranscriptions ? "Has Transcript" : "No Transcript"}>
                                <TooltipHost content={hasTranscriptions ? "View/Edit Audio Transcript" : ""} directionalHint={DirectionalHint.leftCenter}>
                                    <FiEdit size={15} />
                                </TooltipHost>
                            </div>
                        ) : <div/>;
                    }
                }
            ] : []),
            ...(this.props.selectedGroup.assistanttype == "cmp" ?
            [
                {   // comparison diff column
                    key: "kgnf_diff",
                    name: "Diff",
                    fieldName: "highlightItemId",
                    minWidth: 5,
                    maxWidth: 5,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    isPadded: true,
                    onRender: (item: IDocument) => {
                        return (item?.diffids?.length || 0) > 0 ? (
                            item?.diffids.map((diffid: number, index: number) => (
                                <div
                                    onClick={(e: React.MouseEvent<HTMLElement>) => {
                                        let item_second = this._allItems.filter(item => item.key == e.currentTarget.getAttribute("data-item-id"))[0];
                                        this.handleDiffClick([item, item_second], true);
                                    }}
                                    onMouseEnter={() => {this.setState({highlightItemId: diffid.toString()})}}
                                    onMouseLeave={() => {this.setState({highlightItemId: ''})}}
                                    style={{ marginTop: "2px", marginBottom: "-10px", cursor: "pointer" }}
                                    data-item-id={diffid}
                                    data-cval={`Comparison available with item ${diffid}`}
                                >
                                    <TooltipHost content="Comparison between these 2 documents is available" directionalHint={DirectionalHint.leftCenter}>
                                        {this.state.highlightItemId == item.key.toString() ? (<div className={styles.diffItemHighlight}>{diffid}</div>) : (<div className={styles.diffItem}>{diffid}</div>)}
                                    </TooltipHost>
                                </div>
                            ))
                        ) : <div/>;
                    }
                }
            ] : []),
            {   // doc type
                key: "kgnf_type",
                name: "Type",
                fieldName: "doc_category",
                minWidth: 70,
                maxWidth: 70,
                isResizable: false,
                onColumnClick: this._onColumnClick,
                data: "string",
                isPadded: true,
                onRender: (item: IDocument) => {
                    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
                    const dropdownRef = useRef<IDropdown | null>(null);

                    let dropstate = useMemo(() => {
                        return this.props.selectedGroup.permissionlevel >= 1 && item.doc_category && item?.doc_category !== "Pending" && isDropdownVisible
                    }, [isDropdownVisible, this.props.selectedGroup, item.doc_category]);
                    let opt = useMemo(() => {
                        let options = [{ key: item.doc_category, text: item.doc_category || "Pending" }]
                        for (let i = 0; i < detailsListContentTypeOptions.length; i++) {
                            if (item.doc_category != detailsListContentTypeOptions[i].key) options.push(detailsListContentTypeOptions[i]);
                        }
                        return options;
                    }, [isDropdownVisible, item.doc_category]);
                    return dropstate ? (
                        <div data-cval={item.doc_category}>
                            <div style={{ padding: "0px !important", marginTop: "0px", marginBottom: "0px", verticalAlign: "middle" }} >
                                <Dropdown
                                    componentRef={dropdownRef}
                                    selectedKey={item.doc_category}
                                    options={opt}
                                    onChange={(event, option) => this.qChangeType(option?.key || "0", this.props.selectedGroup.selectionId)}
                                    styles={dropdownDetailsListStyles}
                                    onBlur={() => {isDropdownVisible != false && setIsDropdownVisible(false)}}

                                />
                            </div>
                        </div>
                    ) : (
                        <div onClick={() => setIsDropdownVisible(true)} className={styles.drpdwnNotActive} data-cval={item.doc_category}>
                            <TooltipHost content={getTypeTooltipContent(item.doc_category)} styles={tooltipHostStyles} directionalHint={DirectionalHint.topCenter}>
                                {(item.doc_category ?? "Pending") != "Pending" &&
                                    <div className={styles.doccatchevrondown}>
                                        <BiChevronDown />
                                    </div>
                                }
                                <div className={styles.colDocTypeAndStatusText} title={item.doc_category}>{item.doc_category ?? "Pending"}</div>
                            </TooltipHost>
                        </div>
                    );
                }
            },
            {   // processing status
                key: "kgnf_status",
                name: "Status",
                isPadded: false,
                fieldName: "docstatus",
                minWidth: 60,
                maxWidth: 60,
                isResizable: false,
                onColumnClick: this._onColumnClick,
                data: "string",
                onRender: (item: IDocument) => {
                    return (
                        <div className={getStatusColorClass(item)} data-cval={item?.isDeleting == true ? "Deleting" : isItemReady(item) == true ? "Ready" : item?.status_info || item?.docstatus}>
                            <RollingStatus
                                newText={`${item?.isDeleting == true ? "Deleting" : isItemReady(item) == true ? "Ready" : item?.status_info || item?.docstatus}`}
                                details={item?.status_info || ""}
                            />
                        </div>
                    );
                },
            }
        ];

        // 🧩 dynamic dpa columns derived from docsummary.result keys present on any item
        if (this.props.selectedGroup.assistanttype == assistantCodes.dpa) {
            const dpaKeys: string[] = [];
            const seen = new Set<string>();
            const _parseDS = (ds: any) => {
                if (!ds) return null;
                if (typeof ds === "string") {
                    try { return JSON.parse(ds); } catch { return null; }
                }
                return ds;
            };
            for (const it of this._allItems) {
                const ds  = _parseDS((it as any).docsummary);
                const res = ds && typeof ds === "object" ? ds.result : null;
                if (res && typeof res === "object" && !Array.isArray(res)) {
                    for (const k of Object.keys(res)) {
                        if (!seen.has(k)) { seen.add(k); dpaKeys.push(k); }
                    }
                }
            }
            const _prettify = (k: string) =>
                k.replace(/[_\-]+/g, " ").replace(/\b\w/g, c => c.toUpperCase());
            const _stringify = (val: any): string => {
                if (val === null || val === undefined) return "";
                if (typeof val === "object") {
                    try { return JSON.stringify(val); } catch { return ""; }
                }
                return String(val);
            };
            const _isStructured = (val: any): boolean =>
                val !== null && val !== undefined && typeof val === "object";

            const _renderStructured = (val: any): JSX.Element => {
                if (Array.isArray(val)) {
                    if (val.length === 0) return <span className={styles.dpaStructEmpty}>—</span>;
                    // array of primitives → compact inline list
                    if (val.every((v: any) => typeof v !== "object" || v === null)) {
                        return (
                            <div className={styles.dpaStructList}>
                                {val.map((v: any, i: number) => (
                                    <span key={i} className={styles.dpaStructTag}>{String(v ?? "")}</span>
                                ))}
                            </div>
                        );
                    }
                    // array of objects → compact table
                    const allKeys: string[] = [];
                    const seenK = new Set<string>();
                    for (const row of val) {
                        if (row && typeof row === "object" && !Array.isArray(row)) {
                            for (const rk of Object.keys(row)) {
                                if (!seenK.has(rk)) { seenK.add(rk); allKeys.push(rk); }
                            }
                        }
                    }
                    if (allKeys.length > 0) {
                        return (
                            <div className={styles.dpaStructTableWrap}>
                                <table className={styles.dpaStructTable}>
                                    <thead>
                                        <tr>
                                            {allKeys.map(hk => <th key={hk} className={styles.dpaStructTh}>{_prettify(hk)}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {val.slice(0, 10).map((row: any, ri: number) => (
                                            <tr key={ri}>
                                                {allKeys.map(hk => (
                                                    <td key={hk} className={styles.dpaStructTd}>{_stringify(row?.[hk])}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {val.length > 10 && <div className={styles.dpaStructMore}>+{val.length - 10} more</div>}
                            </div>
                        );
                    }
                    // fallback: array of mixed items
                    return (
                        <div className={styles.dpaStructList}>
                            {val.slice(0, 8).map((v: any, i: number) => (
                                <span key={i} className={styles.dpaStructTag}>{_stringify(v)}</span>
                            ))}
                            {val.length > 8 && <span className={styles.dpaStructMore}>+{val.length - 8}</span>}
                        </div>
                    );
                }
                // plain object → key-value pairs
                const entries = Object.entries(val).filter(([, v]) => v !== null && v !== undefined && v !== "");
                if (entries.length === 0) return <span className={styles.dpaStructEmpty}>—</span>;
                return (
                    <div className={styles.dpaStructKV}>
                        {entries.slice(0, 6).map(([ek, ev]) => (
                            <div key={ek} className={styles.dpaStructKVRow}>
                                <span className={styles.dpaStructKey}>{_prettify(ek)}</span>
                                <span className={styles.dpaStructVal}>{_stringify(ev)}</span>
                            </div>
                        ))}
                        {entries.length > 6 && <div className={styles.dpaStructMore}>+{entries.length - 6} more</div>}
                    </div>
                );
            };

            const _pillFor = (txt: string): string | null => {
                const t = txt.trim().toLowerCase();
                if (t === "yes" || t === "true")   return styles.dpaPillYes;
                if (t === "no"  || t === "false")  return styles.dpaPillNo;
                if (t === "almost" || t === "partial" || t === "partially") return styles.dpaPillAlmost;
                return null;
            };

            // insert dynamic dpa columns BEFORE the Modified column
            const modIdx = columns.findIndex(c => c.key === "dateModifiedValue");
            const insertAt = modIdx >= 0 ? modIdx : columns.length;
            const dynCols: IColumn[] = dpaKeys.map(k => ({
                key: `docsum_${k}`,
                name: _prettify(k),
                fieldName: `docsummary.result.${k}`,
                minWidth: 90,
                currentWidth: 150,
                maxWidth: 340,
                isResizable: true,
                isCollapsible: false,
                isPadded: false,
                onColumnClick: this._onColumnClick,
                data: "string",
                onRender: (item: IDocument) => {
                    const ds  = _parseDS((item as any).docsummary);
                    const val = ds && typeof ds === "object" && ds.result ? ds.result[k] : undefined;
                    // structured object/array → rich compact HTML
                    if (_isStructured(val)) {
                        const flatTxt = _stringify(val);
                        return (
                            <div className={styles.colDpaCusto + " " + styles.colDpaSum3} title={flatTxt} data-cval={flatTxt}>
                                {_renderStructured(val)}
                            </div>
                        );
                    }
                    const txt = _stringify(val);
                    if (!txt) return <div className={styles.colDpaSum + " " + styles.colDpaSum1} data-cval=""></div>;
                    const pillCls = _pillFor(txt);
                    if (pillCls) {
                        return (
                            <div data-cval={txt} style={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <span className={styles.dpaPill + " " + pillCls}>{txt.toLowerCase()}</span>
                            </div>
                        );
                    }
                    // adaptive multiline + font shrinking based on text length
                    const len = txt.length;
                    const sizeCls =
                        len <= 18  ? styles.colDpaSum1 :
                        len <= 70  ? styles.colDpaSum2 :
                        len <= 200 ? styles.colDpaSum3 :
                                     styles.colDpaSum4;
                    return (
                        <div className={styles.colDpaSum + " " + sizeCls} title={txt} data-cval={txt}>
                            {txt}
                        </div>
                    );
                }
            }));
            columns.splice(insertAt, 0, ...dynCols);
        }

        // load saved sorting state and apply it to columns
        let savedSort = getLocalSortState(localStorageMainListSorting, this.props.selectedGroup.oid);

        // apply saved sorting to columns
        if (savedSort) {
            columns.forEach(col => {
                if (col.key === savedSort!.key) {
                    col.isSorted = true;
                    col.isSortedDescending = savedSort!.isSortedDescending;
                } else {
                    col.isSorted = false;
                    col.isSortedDescending = true;
                }
            });
        }

        // apply sorting to items if saved sort state exists
        let sortedItems = this._allItems; // bind

        if (savedSort) sortedItems = mainSort(sortedItems, columns.find(col => col.key === savedSort!.key));





        this.state = {
            items: sortedItems,
            columns: columns,
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: true,
            isCompactMode: false,
            announcedMessage: undefined,
            itemSelectionString: '',
            pathSelectionString: [],
            isModalOpen: false,
            isSecurityModalOpen: false,
            isContextMenuVisible: false,
            isSpaceFilterVisible: false,
            contextMenuTarget: null,
            isWorkingOnDelete: false,
            spacesFilter: '',
            activeFile: {},
            hasDeleted: false,
            invoiceModalItem: undefined,
            summaryModalItem: undefined,
            targetItem: undefined,
            callOutVisibilityBool: false,
            aiSearchData: undefined,
            isMicModalVisible: false,
            highlightItemId: undefined,
            isLoading: false,
            isAnalysisModalVisible: false,
            analysisContent: {},
            aiinteractionhighlight: '',
            isAnalysisOptionsVisible: false,
            aioptions: {instructions: ''},
            aioptionsselected: [],
            aiinteractionid: '',
            analysisDocCategory: '',
            itemsCount: { total: sortedItems.length, dataFiles: sortedItems.filter(item => item.doc_category === 'data').length },
            isZeroFiltered: false,
            resizeRandom: { width: window.innerWidth, height: window.innerHeight},
            aiifieldorder: [],
            isColumnCalloutVisible: false,
            hiddenColumnKeys: JSON.parse(localStorage.getItem(`detailsListHiddenCols_${this.props.selectedGroup.oid}`) || '[]'),
            dateFilterColumnKey: null,
            showDataItems: false,
            dataListModalItem: undefined,
            versionsModalItem: undefined,
            versionsList: [],
            isVersionsLoading: false,
            listViews: listViewsSessionCache[this.props.selectedGroup.selectionId] || [],
            columnOrder: JSON.parse(localStorage.getItem(`detailsListColOrder_${this.props.selectedGroup.oid}`) || '[]'),
            activeViewId: null,
            viewNameDraft: '',
            viewIsPublicDraft: false,
            editingViewId: null,
            editingViewName: '',
            dragColKey: null,
            valueFilters: JSON.parse(localStorage.getItem(`detailsListValueFilters_${this.props.selectedGroup.oid}`) || '{}'),
            valueFilterColumnKey: null
        };


        this._selection = new Selection({
            onSelectionChanged: () => {
                import.meta.env.DEV === true && console.log('‹sel›', this.getActiveFile(this._selection.getSelection()));
                this.setState({
                    selectionDetails: this._getSelectionDetails(),
                    itemSelectionString: this._selection
                        .getSelection()
                        .map((item: any) => item?.name)
                        .join(';'),
                    pathSelectionString: this._selection.getSelection().map((item: any) => item?.full_path),
                    activeFile: this.getActiveFile(this._selection.getSelection())
                });
                this.props.onSelectionChange(
                    this._selection.getSelection().map((item: any) => {
                        return { name: item?.name, groupIds: item?.groupIds, groupNames: item?.groupNames };
                    })
                );
            }
        });
    }

    private handleResize = debounce(() => {
        this.setState({ resizeRandom: { width: window.innerWidth, height: window.innerHeight } })
        console.log('‹handleResize›', this.state?.resizeRandom.width, this.state?.resizeRandom.height);
    }, 100);


    public componentDidMount() {
        this.scrollContainer = document.querySelector(`.ms-ScrollablePane--contentContainer`) as HTMLElement;
        let oid = this.props.selectedGroup.oid;

        this.savedScrollLeft = parseInt(localStorage.getItem(horizontalScrollKey(oid))!, 10);
        this.savedScrollPosition = parseInt(localStorage.getItem(vertikalScrollKey(oid))!, 10);

        this.smoothScrollToPosition(this.scrollContainer, this.savedScrollPosition, this.savedScrollLeft);

        // add scroll event listener
        if (this.scrollContainer) this.scrollContainer.addEventListener("scroll", this.saveScrollPosition);

        this.state.items.forEach((item: any) => {
            if (this.props.selectionPass.split(';').includes(item.name)) this._selection.setKeySelected(item.key, true, false);
        });
        const sortedItems = this.applySavedSortToItems(this._allItems);
        this.setState({ items: sortedItems }, () => { setTimeout(() => { this.restoreScrollPosition() }, 50) });

        window.global_lib_mounted = new Date().getTime();
        this.resizeObserver = new ResizeObserver(() => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = window.setTimeout(() => {
                const currentContlist = document.querySelector(`.${styles.customDetailsList}`) as HTMLElement;
                if (currentContlist) currentContlist.style.width = `${Math.max(currentContlist.scrollWidth, window.innerWidth)}px`;

                this.scrollContainer = document.querySelector(`.ms-ScrollablePane--contentContainer`) as HTMLElement;
                if (this.scrollContainer) {
                    smoothScrollLeft(
                        this.scrollContainer,
                        Math.min(
                            parseInt(localStorage.getItem(horizontalScrollKey(this.props.selectedGroup.oid))!, 10),
                            (this.scrollContainer?.scrollWidth - this.scrollContainer?.clientWidth) + 20
                        )
                    );
                }
            }, 100);
        });

        setTimeout(() => {
            const contlist = document.querySelector(`.${styles.customDetailsList}`) as HTMLElement;
            if (contlist) {
                this.resizeObserver?.observe(contlist);
                setTimeout(() => {
                    this.restoreScrollPosition();
                }, 500);
            }
        }, 3000);
        window.addEventListener("resize", this.handleResize);

        this.loadListViews();
    }

    // 🧩 pull saved column views once per group per browser session; served from cache thereafter.
    // Call with force=true after the user creates/updates a view to refresh the cache.
    public loadListViews = async (force: boolean = false) => {
        const groupid = this.props.selectedGroup.selectionId;
        if (!groupid) return;

        if (!force && listViewsSessionCache[groupid]) {
            this.setState({ listViews: listViewsSessionCache[groupid] });
            this.maybeApplyDefaultView(listViewsSessionCache[groupid]);
            return;
        }
        try {
            const views = await qGetListViews(this.props.loggedInUser, groupid);
            listViewsSessionCache[groupid] = views;
            this.setState({ listViews: views });
            if (!force) this.maybeApplyDefaultView(views);
        } catch (error) {
            console.error(error);
        }
    };

    // 🧩 apply the user's default view on first load only (no local column-order cache yet)
    private maybeApplyDefaultView = (views: glistview[]) => {
        const hasLocalOrder = !!localStorage.getItem(`detailsListColOrder_${this.props.selectedGroup.oid}`);
        if (hasLocalOrder || this.state.activeViewId !== null) return;
        const uid = this.props.loggedInUser?.userId || '';
        const def = views.find(v => Array.isArray(v.defaultview) && v.defaultview.includes(uid));
        if (def) this.applyListView(def);
        this.handleResize.cancel();
        this.filterInputDebounced.cancel();
    }

    public componentDidUpdate(previousProps: any, previousState: IDetailsListDocumentsExampleState) {
        if (previousState.isModalSelection !== this.state.isModalSelection && !this.state.isModalSelection) this._selection.setAllSelected(false);
        if (previousProps.fileList !== this.props.fileList) {
            const newItems = parseDocuments(this.props.fileList || [], this.props.selectedGroup.oid);
            let sortedItems = newItems;                             // apply current sorting state to new items
            this.setState({ items: sortedItems });
            setTimeout(() => {
                this.restoreScrollPosition()
            }, 50);   // restore scroll position after items update
        }

        if (this.state.highlightItemId !== previousState.highlightItemId && this.state.highlightItemId !== undefined) {
            this.setState({ items: [...this.state.items] });
            this.scrollContainer = document.querySelector(`.ms-ScrollablePane--contentContainer`) as HTMLElement;
            setTimeout(() => {
                this.restoreScrollPosition()
            }, 50) }   // restore scroll position after highlight update


        // if reference if null › get it & update scroll container
        if (!this.scrollContainer) {
            this.scrollContainer = document.querySelector(`.ms-ScrollablePane--contentContainer`) as HTMLElement;
            if (this.scrollContainer) this.scrollContainer.addEventListener("scroll", this.saveScrollPosition);
        }

        this.restoreScrollPosition();

    }

    private saveScrollPosition = () => {
        if (this.scrollContainer) {
            this.savedScrollPosition = this.scrollContainer.scrollTop;
            this.savedScrollLeft     = this.scrollContainer.scrollLeft;
            localStorage.setItem(vertikalScrollKey(this.props.selectedGroup.oid), this.scrollContainer.scrollTop.toString());
            localStorage.setItem(horizontalScrollKey(this.props.selectedGroup.oid), this.scrollContainer.scrollLeft.toString());
        }
    };

    private smoothScrollToPosition = (container: HTMLElement, top: number, left: number) => {
        if (!container) return;
        if (!top) {
            container?.scrollTo({ left: left, behavior: 'smooth' });
        } else if (!left) {
            container?.scrollTo({ top: top, behavior: 'smooth' });
        } else if (top && left) {
            container?.scrollTo({ top: top, left: left, behavior: 'smooth' });
        }

    }

    private restoreScrollPosition = debounce(() => {
        // clear any existing timeout to debounce rapid calls
        clearTimeout(this.restoreScrollTimeout);
        this.restoreScrollTimeout = window.setTimeout(() => {
            if (this.scrollContainer) {
                if (this.scrollContainer.scrollHeight > this.scrollContainer.clientHeight){
                    this.smoothScrollToPosition(
                        this.scrollContainer,
                        Math.min(this.savedScrollPosition, this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight),
                        Math.min(this.savedScrollLeft, (this.scrollContainer?.scrollWidth - this.scrollContainer?.clientWidth) + 20)
                    );
                }
            }
        }, 400);
    }, 200);


    private applySavedSortToItems = (items: any[]): any[] => {
        const savedSort = getLocalSortState(localStorageMainListSorting, this.props.selectedGroup.oid);
        if (!savedSort) return items;
        try {
            const sorted = mainSort(items, savedSort);
            this.restoreScrollPosition()
            return sorted;
        } catch (e) {
            console.warn('failed to apply saved sort state:', e);
        }
        return items;
    };

    public getActiveFile = (selection: any) => {
        if (selection?.length > 0) {
            const selFileKey = selection.map((item: any) => item?.key)[0] || "";
            const selectedFile = (this.props.fileList || []).filter(item => item?.fileid == selFileKey);
            return selectedFile[0] || {};
        }
    };

    // context menu
    private detectColumnKeyFromEvent = (ev: Event | undefined): string | undefined => {
        const target = (ev as PointerEvent)?.target as HTMLElement | undefined;
        const cell = target?.closest?.('[data-automationid="DetailsRowCell"]') as HTMLElement | undefined;
        return cell?.getAttribute('data-automation-key') ?? undefined;
    };

    public onItemContextMenu = (item: any, index: number | undefined, ev: Event | undefined): boolean | void => {
        (ev as PointerEvent)?.preventDefault();

        this.contextMenuColumnKey = this.detectColumnKeyFromEvent(ev);
        if (this.props.selectedGroup.permissionlevel >= 2 || this.props.selectedGroup.viewerscanupload == 1) {
            this.setState({
                isContextMenuVisible: true,
                targetItem: item,
                contextMenuTarget: { x: ev ? (ev as PointerEvent).clientX : 0, y: ev ? (ev as PointerEvent).clientY : 0 }
            });
        }
        return true;
    };

    // context menu click handlers
    public onContextMenuItemClick = (ev?: any, item?: IContextualMenuItem | undefined) => {
        if (item?.key === "Share") {
            this.showSecurityModal();
        } else if (item?.key === "Download") {
            this.handleDownloadClick(this._selection.getSelection());
        } else if (item?.key === "Reindex") {
            this.handleReindexClick(this._selection.getSelection());
        } else if (item?.key === "Invoice") {
            this.handleInvExtractClick(this._selection.getSelection());
        } else if (item?.key === "Delete") {
            this.gHandleBatchDelete(this._selection.getSelection());
        } else if (item?.key === "IndexView") {
            this.handleIndexViewClick(this._selection.getSelection());
        } else if (item?.key === "Diff") {
            this.handleDiffClick(this._selection.getSelection(), false);
        } else if (item?.key === "Analyse") {
            this.handleAnalyseOptionsClick(this._selection.getSelection(), false);
        } else if (item?.key === "CopyNames") {
            this.handleCopyNamesOptionsClick(this._selection.getSelection(), false);
        } else if (item?.key === "CopyValue") {
            this.handleCopyValueOptionsClick(this._selection.getSelection());
        } else if (item?.key === "RerunPreconfAnalysis") {
            this.handleRerunPreconfAnalysisOptionsClick(this._selection.getSelection(), false);
        } else if (item?.key === "Versions") {
            this.handleVersionsClick(this.state.targetItem);
        } else if (item?.key === "DashList") {
            this.qSetDashList_dash(this.state.targetItem?.fileid, this.state.targetItem?.dash_list == 1 ? 0 : 1);
        }
        this.setState({ isContextMenuVisible: false });
    };

    // context menu handlers
    public handleDownloadClick = async (items: any[]) => {
        const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
        for (let i = 0; i < items.length; i++) {
            await downloadPDF(getContentPathWithId(items[i].name, items[i].key), items[i].name, this.props.companyId, this.props.loggedInUser, items[i]?.rekey);
            await sleep(250); // allow disk i/o and browser download kick-off
        }
    };

    public handleReindexClick = async (items: any[]) => {
        let itemAppendedStrings = [];
        let modStrings = [];
        let idStrings = [];
        let itemLens = []
        for (let i = 0; i < items.length; i++) {
            itemAppendedStrings.push(getContentPathWithId(items[i].name, items[i].key));
            modStrings.push(new Date(this.getItemFromSel(items[i].name)?.dateModified)?.getTime()?.toString());
            idStrings.push(items[i].key);
            itemLens.push((items[i]?.pagedimensions ?? []).length);
        }
        let itemAppendedArr = itemAppendedStrings.join(";");
        let itemAppendedLen = itemLens.join(";");
        let reindexParams: greindexparams = {
            fileString: itemAppendedArr,
            selectedGroup: this.props.selectedGroup,
            userId: this.props.loggedInUser.userId,
            company: this.props.companyId,
            header: getHeader(this.props.loggedInUser),
            modString: modStrings?.join(";"),
            idString: idStrings?.join(";"),
            doc_page_len: itemAppendedLen
        };
        this._allItems = _onLoadSort(this.state.items, this.props.selectedGroup.oid);
        this._allItems = this._allItems.map(currentItem => {
            if (items.some(selFile => selFile.key === currentItem.key)) return { ...currentItem, docstatus: "Reindexing" };
            return currentItem;
        });

        const sortedItems = this.applySavedSortToItems(this._allItems);

        this.setState({ items: sortedItems }, () => {
            // restore scroll position after reindexing status update
            setTimeout(() => {this.restoreScrollPosition()}, 50);
        });
        const response = await reprocessDocs(reindexParams, this.props.listRefreshRequest);
        if (response.success !== true) {
            throw Error("failed_reindex_file");
        } else {
            this.props.updateCatsState(itemAppendedArr);
        }
    };

    public handleInvExtractClick = async (items: any[]) => {
        let itemAppendedStrings = [];
        let modStrings = [];
        let idStrings = [];
        let itemLens = []
        for (let i = 0; i < items.length; i++) {
            itemAppendedStrings.push(this.getContentPath(items[i].name));
            modStrings.push(new Date(this.getItemFromSel(items[i].name)?.dateModified)?.getTime()?.toString());
            idStrings.push(items[i].key);
            itemLens.push((items[i]?.pagedimensions ?? []).length);
        }
        let itemAppendedArr = itemAppendedStrings.join(";");
        let reindexParams: greindexparams = {
            fileString: itemAppendedArr,
            selectedGroup: this.props.selectedGroup,
            userId: this.props.loggedInUser.userId,
            company: this.props.companyId,
            header: getHeader(this.props.loggedInUser),
            modString: modStrings?.join(";"),
            idString: idStrings?.join(";"),
            doc_page_len: itemLens.join(";")
        };
        const response = await dataExtractionApi(reindexParams, this.props.listRefreshRequest);
        if (response.success !== true) {
            throw Error("Failed reindexFile");
        } else {
            this.props.updateCatsState(itemAppendedArr);
        }
    };

    public handleIndexViewClick = async (items: any[]) => {
        const params = new URLSearchParams({
            fkey: items[0].key,
            companyid: this.props.companyId
        });
        const url = "/srch_by_filename" + `?${params.toString()}`;
        const response = await fetch(url, {
            headers: getHeader(this.props.loggedInUser)
        });
        let indx_results = await response.json();
        this.setState({
            aiSearchData: {
                title: items[0].name,
                indx_results: indx_results
            }
        });
    };

    public prepDiffCitationURL = (item: any) => {
        return `${item.name}#page=1_fid=${item.key}`;
    };

    public handleDiffClick = async (items: any[], isCellButton: boolean) => {
        if (isCellButton) {
            if (items.length == 2) {
                let itemids = items.map(item => item.key);
                if (
                    (items[0].diffids.includes(items[0].key) || items[0].diffids.includes(items[1].key)) &&
                    (items[1].diffids.includes(items[0].key) || items[1].diffids.includes(items[1].key))
                ) {
                    this.setState({ isLoading: true });
                    let diff_results: gdiffresponse[] = await getAiDiff(items[0].key, items[1].key, this.props.loggedInUser);
                    this.setState({ isLoading: false });
                    this.props.onCompareClicked(this.prepDiffCitationURL(items[0]), this.prepDiffCitationURL(items[1]), diff_results);
                } else {
                    if (items[0].diffids.length < 1 || items[1].diffids.length < 1) {
                        let mod0 = get_mod_str(items[0].modified);
                        let mod1 = get_mod_str(items[1].modified);
                        await ai_comparison(
                            items[0].key,
                            items[1].key,
                            this.props.loggedInUser,
                            this.props.companyId,
                            mod0,
                            mod1,
                            items[0].ownerid,
                            items[1].ownerid,
                            this.props.listRefreshRequest
                        );
                    } else {
                        toast.error("Multiple comparisons per file are not available in demo");
                    }
                }
            } else {
                toast.error("Please select 2 files to compare");
            }
        } else {
            if (items.length == 2) {
                if (items[0].diffids.length < 1 || items[1].diffids.length < 1) {
                    // Fresh Files
                    let mod0 = get_mod_str(items[0].modified);
                    let mod1 = get_mod_str(items[1].modified);
                    await ai_comparison(
                        items[0].key,
                        items[1].key,
                        this.props.loggedInUser,
                        this.props.companyId,
                        mod0,
                        mod1,
                        items[0].ownerid,
                        items[1].ownerid,
                        this.props.listRefreshRequest
                    );
                } else {
                    if (
                        (items[0].diffids.includes(items[0].key) || items[0].diffids.includes(items[1].key)) &&
                        (items[1].diffids.includes(items[0].key) || items[1].diffids.includes(items[1].key))
                    ) {
                        // Recompare
                        let mod0 = get_mod_str(items[0].modified);
                        let mod1 = get_mod_str(items[1].modified);
                        await ai_comparison(
                            items[0].key,
                            items[1].key,
                            this.props.loggedInUser,
                            this.props.companyId,
                            mod0,
                            mod1,
                            items[0].ownerid,
                            items[1].ownerid,
                            this.props.listRefreshRequest
                        );
                    } else {
                        toast.error("Multiple comparisons per file are not available in demo");
                    }
                }
            } else {
                toast.error("Please select 2 files to compare");
            }
        }
    };

    public handleAnalyseOptionsClick = async (items: IObjectWithKey[], isCellButton: boolean) => {
        this.setState({ isAnalysisOptionsVisible: true, aioptionsselected: items });
    };

    public handleCopyNamesOptionsClick = async (items: IObjectWithKey[], isCellButton: boolean) => {
        let names = items.map(item => (item as any)["name"]).join("\n");
        navigator.clipboard
            .writeText(names)
            .then(() => {
                toast.success("Copied selected item names to clipboard");
            })
            .catch(err => {
                toast.error("Failed to copy selected item names to clipboard");
            });
    };

    public handleCopyValueOptionsClick = async (items: IObjectWithKey[]) => {
        const colKey = this.contextMenuColumnKey;
        const propPath = colKey ? (keyToFileProp as Record<string, string>)[colKey] : undefined;
        const col = this.state.columns.find(c => c.key === colKey);

        if (!propPath) return;

        const values = items.map(item => {
            const val = propPath.includes(".") ? getByPath(item, propPath) : (item as any)[propPath];
            return val != null ? String(val) : "";
        });
        const text = values.join("\n");

        navigator.clipboard
            .writeText(text)
            .then(() => {
                toast.success(`Copied ${col?.name || "value"} to clipboard`, { autoClose: 1000 });
            })
            .catch(err => {
                toast.error("Failed to copy value to clipboard", { autoClose: 1000 });
            });
    };

    public handleRerunPreconfAnalysisOptionsClick = async (items: IObjectWithKey[], isCellButton: boolean) => {
        let preconf_opt = this.props.selectedGroup?.contenttype_config?.postaianalysisoptions?.preconfopt;

        reRunPreconfAnalysis(items, preconf_opt || "0", getHeader(this.props.loggedInUser), this.props.selectedGroup).then((res: any) => {});
    };


    // 🕰️ align each metadata version to the uploaded (first-version) file whose upload time is the
    // latest one at or before the version stamp. Multiple metadata versions may map to the same file.
    // versions arrive ordered id DESC, so index 0 is the current (latest) version → flagged isLatest.
    private alignVersionsToFiles = (versions: gversionrow[]): gversionrow[] => {
        return versions.map((v, idx) => {
            const rehydrate = v.rehydrate || {};
            const entries = Object.entries(rehydrate)
                .map(([k, val]) => ({ keyNum: parseRehydrateKeyToMs(k), entry: val }))
                .sort((a, b) => a.keyNum - b.keyNum); // ascending by upload time

            const isLatest = idx === 0;

            if (entries.length === 0) return { ...v, linkedFile: null, isLatest };

            // version stamp as comparable number in same yyyymmddHHsshh space (best-effort)
            const stampNum = v.stamp ? Number(new Date(v.stamp).getTime()) : 0;

            // pick the latest uploaded file whose upload time is <= the version stamp;
            // if none qualify (stamp older than any upload), fall back to the earliest upload.
            let picked = entries[0].entry;
            for (const e of entries) {
                // compare using the upload key's real datetime; the key encodes yyyymmddHHss(hh)
                const uploadDate = rehydrateKeyToDate(String(e.keyNum));
                if (uploadDate && uploadDate.getTime() <= stampNum) {
                    picked = e.entry;
                } else if (uploadDate && uploadDate.getTime() > stampNum) {
                    break;
                }
            }
            return { ...v, linkedFile: picked, isLatest };
        });
    };


    // 🕰️ open versions modal and load available invoicedata versions for the file
    public handleVersionsClick = async (item: any) => {
        if (!item) return;
        this.setState({ versionsModalItem: item, versionsList: [], isVersionsLoading: true });
        try {
            const versions: gversionrow[] = await qGetVersions(this.props.loggedInUser, item.key?.toString());
            const aligned = this.alignVersionsToFiles(Array.isArray(versions) ? versions : []);
            this.setState({ versionsList: aligned, isVersionsLoading: false });
        } catch (e) {
            toast.error("Failed to load versions");
            this.setState({ isVersionsLoading: false });
        }
    };

    // 🕰️ download the uploaded file aligned to a version row
    public handleVersionFileDownload = async (version: gversionrow) => {
        const lf = version.linkedFile;
        if (!lf || !lf.blobpath) {
            toast.info("No file available for this version");
            return;
        }
        try {
            await downloadVersionFile(this.props.loggedInUser, this.props.companyId, lf.blobpath, lf.filename || "download.pdf");
        } catch (e) {
            toast.error("Failed to download file");
        }
    };

    public hideVersionsModal = () => this.setState({ versionsModalItem: undefined, versionsList: [] });

    // 🕰️ load a previous invoicedata version and open it in the FULL invoice interface (pdf + main + line items).
    // the fetched invoicedata is passed as a transient view-only override; it is NOT written back to list/cache.
    public handleVersionSelect = async (version: gversionrow) => {
        const item = this.state.versionsModalItem;
        if (!item) return;
        if (this.versionFileClickGuard) { this.versionFileClickGuard = false; return; } // 🕰️ file link was clicked, not the row
        if (version.isLatest) return;   // 🕰️ current version — already shown in the normal editor, do nothing
        this.setState({ isVersionsLoading: true });
        try {
            const record: gversionrow = await qGetVersionData(this.props.loggedInUser, version.id?.toString());
            let invdata = record?.invoicedata;
            if (typeof invdata === "string") {
                try { invdata = JSON.parse(invdata || "null"); } catch { /* keep as-is */ }
            }
            this.setState({ isVersionsLoading: false, versionsModalItem: undefined, versionsList: [] });
            // open the full interface with the transient version data (view-only)
            const fileId = (item.key ?? item.fileid)?.toString() || "";
            if (this.props.onVersionInvoiceOpen) {
                this.props.onVersionInvoiceOpen(fileId, item.name || "", invdata);
            }
        } catch (e) {
            toast.error("Failed to load version data");
            this.setState({ isVersionsLoading: false });
        }
    };

    public handleAnalyseButtonClick = async (items: IObjectWithKey[], isCellButton: boolean) => {
        let json_arr: gfanalyse[] = [];
        let fids: string[] = [];

        items.forEach(async item => {
            fids.push((item as any)["key"].toString());
            let itm = item as gfile;
            json_arr.push({
                filename: itm.name,
                structured_data_per_page: itm.invoicedata
            });
        });
        this.setState({ isLoading: true });
        const firstDocCategory = items.length > 0 ? (items[0] as any).doc_category || "" : "";
        qJsonAnalysis(json_arr, getHeader(this.props.loggedInUser), fids, this.props.selectedGroup.selectionId).then(res => {
            this.setState({ aiinteractionid: "" });
            this.setState({ aiifieldorder:  [] });
            this.setState({ analysisContent: res });
            this.setState({ analysisDocCategory: firstDocCategory });
            this.setState({ isAnalysisModalVisible: true });
            this.setState({ isLoading: false });
            this.props.listRefreshRequest();
        });
    };

    public handleAIInteractionClick = (aiintid: string, docCategory: string = '', fid: string) => {
        /**
         * Handle existing analysis click
         * @param aiintid The AI interaction ID
         * @param docCategory The document category
         * @param fid The file ID
         */
        qJsonAnalysisRecall(aiintid, docCategory, getHeader(this.props.loggedInUser), this.props.selectedGroup.selectionId, fid).then(res => {
            this.setState({ aiinteractionid: aiintid });
            this.setState({ aiifieldorder:  JSON.parse(res.fieldorder) });
            this.setState({ analysisContent: JSON.parse(res.content) });
            this.setState({ analysisDocCategory: docCategory });
            this.setState({ isAnalysisModalVisible: true });
            this.setState({ isLoading: false });
        });
    };

    public qChangeType = async (doc_category: string | number, selectionId:string) => {
        fetch(`/qChangeFileType`, {
            method: "POST",
            headers: getHeader(this.props.loggedInUser),
            body: JSON.stringify({ fid: this.state.activeFile.fileid, doc_category: doc_category, gid: selectionId })
        }).then(res => {
            if (!res || res.ok == false) {
                toast.error("Error Changing Item Type");
            } else {
                toast.success("Changed Item Type");
                this.props.listRefreshRequest();
            }
        });
    };

    // 📋 toggle a data item as a sidebar list (files.extra_conf.dash_list)
    public qSetDashList_dash = async (fid: string | number | undefined, dash_list: number) => {
        if (!fid) return;
        try {
            const res = await fetch(`/qSetDashList`, {
                method: "POST",
                headers: getHeader(this.props.loggedInUser),
                body: JSON.stringify({ fid: fid, dash_list: dash_list, gid: this.props.selectedGroup.selectionId })
            });
            if (!res || res.ok == false) {
                toast.error("Error Updating Sidebar Lists");
            } else {
                // toast.success(dash_list == 1 ? "Added to Sidebar Lists" : "Removed from Sidebar Lists");
                this.props.listRefreshRequest(fid.toString());
            }
        } catch {
            toast.error("Error Updating Sidebar Lists");
        }
    };

    private isDashListGroup_dash = () => {
        const at = this.props.selectedGroup.assistanttype;
        return at == assistantCodes.ipa || at == assistantCodes.dpa || at == assistantCodes.cca;
    };

    public qApprove = async () => {
        fetch(`/qApprove`, {
            method: "POST",
            headers: getHeader(this.props.loggedInUser),
            body: JSON.stringify({ fid: this.state.activeFile.fileid, approver_id: this.props.loggedInUser?.userId || "", group_id: this.props.selectedGroup.selectionId })
        }).then(res => {
            if (!res || res.ok == false) {
                toast.error("Error Approving Item");
            } else {
                toast.success("Item Approved");
                this.props.listRefreshRequest();
            }
        });
    };

    public gHandleBatchDelete = async (selFiles: IObjectWithKey[]) => {
        let fileids    = selFiles.map(file => file["key"]).join(";");
        let filenames  = selFiles.map(file => (file as any)["name"] as string).join(";");
        let filesToDel = this._allItems.filter(item => selFiles.some(selFile => selFile.key?.toString() == item.key?.toString()));
        let filesKeep  = this._allItems.filter(item => selFiles.every(selFile => selFile.key?.toString() != item.key?.toString()));
        let filenms    = filenames;

        if (filesKeep.length == 0) this.setState({ isZeroFiltered: true });

        this._allItems = this._allItems.map(currentItem => {
            if (selFiles.some(selFile => selFile.key === currentItem.key)) return { ...currentItem, isDeleting: true };
            return currentItem;
        });

        this.setState({items: _onLoadSort(this._allItems, this.props.selectedGroup.oid)});

        let response = await deleteFile(filenms, fileids, getHeader(this.props.loggedInUser), this.props.companyId, this.props.selectedGroup.selectionId,this.props.listRefreshRequest);
        if (response.success !== true) {
            throw Error("failed_deletefile");
        } else {
            this._allItems = filesKeep;
            const sortedItems = _onLoadSort(this._allItems, this.props.selectedGroup.oid)
            this.setState({
                items: sortedItems,
                hasDeleted: true
            }, () => {
                // restore scroll position after deletion
                setTimeout(() => {this.restoreScrollPosition()}, 50);
            });
            this.props.onDelFile();
        }
    };

    public onSpaceFilterClick = (option?: IDropdownOption) => {
        let items = this.filterSpace(option?.key as string);
        items = this.applySavedSortToItems(items); // apply sorting after space filtering
        this.setState({ items: items, spacesFilter: option?.key ? (option.key as string) : "" }, () => {
            // restore scroll position after space filtering
            setTimeout(() => {this.restoreScrollPosition()}, 50);
        });
    };

    public qHandleFileSelectionSpaceChange = async (selectionId: string, selectionText: string) => {
        let selFiles = this._selection.getSelection();
        let fileids = selFiles.map(file => file.key).join(';');
        selFiles.forEach(async (file: any) => {
            const response = await fetch("/qSetFilePermissions", {
                method: "POST",
                headers: getHeader(this.props.loggedInUser),
                body: JSON.stringify({ fileKey: file.key, groupKey: selectionId })
            });
            this._allItems = this._allItems.map(item => {
                if (item.key === file.key) {
                    return { ...item, groupIds: selectionId ? selectionId?.split(",") : [], groupNames: selectionText ? selectionText?.split(',') : [] }; // spread the original item and update the Group Props
                }
                return item;
            });
            const sortedItems = this.applySavedSortToItems(this._allItems);
            this.setState({ items: sortedItems }, () => {
                // restore scroll position after space change
                setTimeout(() => {this.restoreScrollPosition();}, 50);
            });
            this.props.fileSpaceChangeTrigger(new Date().toISOString());
        });
        this.hideSecurityModal();
        const response = await fetch("/srch_update", {
            method: "POST",
            headers: getHeader(this.props.loggedInUser),
            body: JSON.stringify({ fileids: fileids, groupids: selectionId, companyid: this.props.companyId })
        });
    };

    public showInvoiceModal = (itm: IDocument) => {
        this.setState({ invoiceModalItem: itm });
    };

    public getContentPath = (itemSelectionString: string) => {
        const itemSel = itemSelectionString.split(';')[0];
        const itemid = this._allItems.filter(item => item.name == itemSel).map(item => item.key)[0];
        const contPath = `${itemSel}_fid=${itemid}`;
        return contPath;
    };

    public getContentPathWithId = (itemSelectionString: string, itemKey: string) => {
        const itemSel = itemSelectionString.split(';')[0];
        const contPath = `${itemSel}_fid=${itemKey}`;
        return contPath;
    };

    private _exportDpaInvDataCsv = async () => {
        try {
            const baseName = (this.props.selectedGroup?.selectionId || "data").toString().replace(/[\\/:*?"<>|]+/g, "_");
            const pageCount = await exportInvDataCSV(this._allItems || [], baseName);
            if (pageCount === 0) toast.info("No structured data to export");
        } catch (e) {
            toast.error("Failed to export CSV");
        }
    };

    public getItemFromSel = (itemSelectionString: string) => {
        return this._allItems.filter(item => item.name == itemSelectionString.split(";")[0])[0];
    };

    public handleDocumentDisplay = async (item: any) => {
        import.meta.env.DEV === true && console.log('‹dicdisplay›', item);

        if (isItemReady(item) == true) {
            if ((this.props.selectedGroup.assistanttype == assistantCodes.ipa || this.props.selectedGroup.assistanttype == assistantCodes.dpa || this.props.selectedGroup.assistanttype == assistantCodes.cca) && item.doc_category == "data" && item.invoicedata) {
                let invdata = typeof item.invoicedata === "string" ? JSON.parse(item.invoicedata || "null") : item.invoicedata;
                // when the list only carries a placeholder ({doc_category: ...}) and not the actual rows, pull the full invoicedata from the backend before opening the modal.
                if (!Array.isArray(invdata) && invdata && typeof invdata === "object" && Object.keys(invdata).length === 1 && "doc_category" in invdata) {
                    try {
                        this.setState({ isLoading: true });
                        const record = await getBaseAiData(this.props.loggedInUser, this.props.selectedGroup, item.key?.toString());
                        invdata = record?.invoicedata ?? invdata;
                    } catch (e) {
                        toast.error("Failed to load data");
                    } finally {
                        this.setState({ isLoading: false });
                    }
                }
                this.setState({ dataListModalItem: { ...item, invoicedata: invdata } });
            } else {
                this.props.onCitationClicked(`${item.name}#page=1_fid=${item.key}`, null);
            }
        } else {
            toast.warning(`"Item not Ready Yet ${item.docstatus}`);
        }
    };

    public publishTranscriptDraftHandler = async (trnscptPbls: gtranscriptpublish, listRefreshRequest: (fileids?: string) => void) => {
        try {
            await publishTranscriptDraft(trnscptPbls, listRefreshRequest);
        } catch (error) {
            console.error(error);
        }
    };

    public callOutVisibility = (callOutVisibility: boolean) => {};

    // main list column visibility
    private toggleColumnVisibility = (columnKey: string) => {
        this.setState(prevState => {
            const hidden = prevState.hiddenColumnKeys.includes(columnKey)
                ? prevState.hiddenColumnKeys.filter(k => k !== columnKey)
                : [...prevState.hiddenColumnKeys, columnKey];

            localStorage.setItem(`detailsListHiddenCols_${this.props.selectedGroup.oid}`, JSON.stringify(hidden));

            return { hiddenColumnKeys: hidden };
        });
    };

    // 🧩 reorder the schema columns by the saved columnOrder; unknown/new keys keep schema order at the end
    private applyColumnOrder = (columns: IColumn[]): IColumn[] => {
        const order = this.state.columnOrder;
        if (!order || order.length === 0) return columns;
        const rank = new Map(order.map((k, i) => [k, i]));
        return [...columns].sort((a, b) => {
            const ra = rank.has(a.key) ? rank.get(a.key)! : Number.MAX_SAFE_INTEGER;
            const rb = rank.has(b.key) ? rank.get(b.key)! : Number.MAX_SAFE_INTEGER;
            return ra - rb;
        });
    };

    // 🧩 persist column order locally (localStorage cache) and mark the applied view ad-hoc
    private persistColumnOrder = (order: string[]) => {
        localStorage.setItem(`detailsListColOrder_${this.props.selectedGroup.oid}`, JSON.stringify(order));
        this.setState({ columnOrder: order });
    };

    // 🧪 distinct values present for a filterable column, computed from the full item set
    private getDistinctColumnValues = (columnKey: string): { raw: string; label: string; count: number }[] => {
        const cfg = valueFilterableCols.find(c => c.key === columnKey);
        if (!cfg) return [];
        const counts = new Map<string, number>();
        for (const item of this._allItems) {
            const raw = cfg.getValue(item);
            counts.set(raw, (counts.get(raw) || 0) + 1);
        }
        return Array.from(counts.entries())
            .map(([raw, count]) => ({ raw, label: cfg.getLabel(raw), count }))
            .sort((a, b) => a.label.localeCompare(b.label));
    };

    // 🧪 toggle a value in a column's filter set; persisted in the same cache system as sort/visibility
    private toggleValueFilter = (columnKey: string, raw: string) => {
        this.setState(prev => {
            const cur = prev.valueFilters[columnKey] || [];
            const next = cur.includes(raw) ? cur.filter(v => v !== raw) : [...cur, raw];
            const filters = { ...prev.valueFilters };
            if (next.length === 0) delete filters[columnKey]; else filters[columnKey] = next;
            localStorage.setItem(`detailsListValueFilters_${this.props.selectedGroup.oid}`, JSON.stringify(filters));
            return { valueFilters: filters };
        });
    };

    private clearValueFilter = (columnKey: string) => {
        this.setState(prev => {
            const filters = { ...prev.valueFilters };
            delete filters[columnKey];
            localStorage.setItem(`detailsListValueFilters_${this.props.selectedGroup.oid}`, JSON.stringify(filters));
            return { valueFilters: filters, valueFilterColumnKey: null };
        });
    };

    // 🧪 apply active value filters (OR within a column, AND across columns). Runs on top of search output.
    private applyValueFilters = (list: any[]): any[] => {
        const active = Object.entries(this.state.valueFilters).filter(([, vals]) => vals && vals.length > 0);
        if (active.length === 0) return list;
        return list.filter(item =>
            active.every(([colKey, vals]) => {
                const cfg = valueFilterableCols.find(c => c.key === colKey);
                return cfg ? vals.includes(cfg.getValue(item)) : true;
            })
        );
    };

    // 🧩 move a column key before another within the current ordered, name-bearing column list
    private reorderColumn = (dragKey: string, dropKey: string) => {
        if (dragKey === dropKey) return;
        const ordered = this.applyColumnOrder(this.state.columns).filter(c => c.name && c.name.trim() !== '');
        const keys = ordered.map(c => c.key);
        const from = keys.indexOf(dragKey);
        const to   = keys.indexOf(dropKey);
        if (from < 0 || to < 0) return;
        keys.splice(to, 0, keys.splice(from, 1)[0]);
        this.persistColumnOrder(keys);
    };

    // 🧩 apply a saved view: set column order + hidden columns (+ value filters) from the view payload
    private applyListView = (view: glistview) => {
        const allKeys = this.state.columns.filter(c => c.name && c.name.trim() !== '').map(c => c.key);
        // viewcols is either a legacy string[] (cols only) or a gviewpayload object ({cols, valueFilters})
        const payload: gviewpayload = Array.isArray(view.viewcols) ? { cols: view.viewcols } : (view.viewcols || { cols: [] });
        const viewKeys = payload.cols || [];
        const vFilters = payload.valueFilters || {};
        // viewcols holds the visible columns in order; everything else is hidden (except locked cols)
        const hidden = allKeys.filter(k => !viewKeys.includes(k) && !noVisibilityChangeCols.includes(k));
        localStorage.setItem(`detailsListColOrder_${this.props.selectedGroup.oid}`, JSON.stringify(viewKeys));
        localStorage.setItem(`detailsListHiddenCols_${this.props.selectedGroup.oid}`, JSON.stringify(hidden));
        localStorage.setItem(`detailsListValueFilters_${this.props.selectedGroup.oid}`, JSON.stringify(vFilters));
        this.setState({ columnOrder: viewKeys, hiddenColumnKeys: hidden, valueFilters: vFilters, activeViewId: view.id });
    };

    // 🧩 build the persisted view payload from the current layout (cols + value filters)
    private currentViewPayload = (): gviewpayload => {
        return { cols: this.currentViewCols(), valueFilters: this.state.valueFilters };
    };

    // 🧩 the current visible columns in display order — this is what a view stores
    private currentViewCols = (): string[] => {
        return this.applyColumnOrder(this.state.columns)
            .filter(c => c.name && c.name.trim() !== '' && !this.state.hiddenColumnKeys.includes(c.key))
            .map(c => c.key);
    };

    // 🧩 create a new saved view from the current layout
    private saveNewView = async () => {
        const name = this.state.viewNameDraft.trim();
        if (!name) { toast.warning("Enter a view name"); return; }
        try {
            const saved = await qSaveListView(this.props.loggedInUser, {
                groupid: this.props.selectedGroup.selectionId,
                viewname: name,
                viewcols: this.currentViewPayload(),
                ispublic: this.state.viewIsPublicDraft
            });
            this.setState({ viewNameDraft: '', viewIsPublicDraft: false, activeViewId: saved.id });
            await this.loadListViews(true);
            toast.success("View saved");
        } catch (error) {
            console.error(error);
            toast.error("Failed to save view");
        }
    };

    // 🧩 update an existing owned view's layout (and optionally name/public via inline edit)
    private updateView = async (view: glistview, overrides?: Partial<glistview>) => {
        try {
            await qSaveListView(this.props.loggedInUser, {
                id: view.id,
                groupid: this.props.selectedGroup.selectionId,
                viewname: overrides?.viewname ?? view.viewname ?? '',
                viewcols: overrides?.viewcols ?? this.currentViewPayload(),
                ispublic: overrides?.ispublic ?? !!view.ispublic
            });
            await this.loadListViews(true);
            toast.success("View updated");
        } catch (error) {
            console.error(error);
            toast.error("Failed to update view");
        }
    };

    // 🧩 delete an owned view
    private deleteView = async (view: glistview) => {
        try {
            await qDelListView(this.props.loggedInUser, view.id);
            if (this.state.activeViewId === view.id) this.setState({ activeViewId: null });
            await this.loadListViews(true);
            toast.info("View deleted");
        } catch (error) {
            console.error(error);
            toast.error("Failed to delete view");
        }
    };

    // 🧩 set/clear a view as the current user's default for this group
    private toggleDefaultView = async (view: glistview) => {
        const uid = this.props.loggedInUser?.userId || '';
        const isCurrentlyDefault = Array.isArray(view.defaultview) && view.defaultview.includes(uid);
        try {
            await qSetDefaultView(this.props.loggedInUser, this.props.selectedGroup.selectionId, view.id, !isCurrentlyDefault);
            await this.loadListViews(true);
        } catch (error) {
            console.error(error);
            toast.error("Failed to set default view");
        }
    };

    public showSecurityModal = () => this.setState({ isSecurityModalOpen: true });

    public hideSecurityModal = () => this.setState({ isSecurityModalOpen: false });

    public hideInvoiceModal = () => this.setState({ invoiceModalItem: undefined });

    public hideAISearchDataModal = () => this.setState({ aiSearchData: undefined });

    public hideSummaryModal = () => this.setState({ summaryModalItem: undefined });

    public isMicModalVisible = () => {
        this.props.listRefreshRequest();
        let fid = this.state.activeFile?.fileid;
        this.setState({ isMicModalVisible: false, activeFile: {} });
        this._selection.setKeySelected(fid, false, false);

    };

    public removeaiinteraction = (aiinteractionid: string) => {
        qJsonAnalysisRemove(aiinteractionid, getHeader(this.props.loggedInUser), this.props.selectedGroup.selectionId).then((res: any) => {
            this.setState({
                aiinteractionid: aiinteractionid,
                isAnalysisModalVisible: false
            });
            this.props.listRefreshRequest();
        });
    }

    private getSpaceFilterChoices = () => {
        const itCh: IContextualMenuItem[] = this.props.groupList
            .filter(option => option.key !== "FileSelect")
            .map(option => ({
                key: option.key.toString(),
                text: option.text,
                onClick: () => this.onSpaceFilterClick(option)
            }));
        return itCh;
    };

    private filter = (text?: string): any[] => {
        if (!text || text.trim() === '') {
            return this._allItems;
        } else {
            return this._allItems.filter(i => includesTextNested(i, text)) || this._allItems;
        }

    };

    private filterSpace = (text?: string): any[] => {
        return text
            ? this._allItems.filter(i => i.groupIds?.includes(text ? text : '') || (i.filerole && text == "MyFiles")) || this._allItems
            : this._allItems;
    };

    private runFilterAsync = async (text?: string): Promise<void> => {
        const runSeq = ++this.filterRunSeq;

        // Yield control so keystrokes/render can flush before heavy filtering.
        await new Promise<void>(resolve => window.setTimeout(resolve, 0));

        // Drop stale runs when user keeps typing.
        if (runSeq !== this.filterRunSeq) return;

        let items = this.filter(text);
        items = this.applySavedSortToItems(items); // apply sorting after filtering

        if (runSeq !== this.filterRunSeq) return;

        this.setState({
            isZeroFiltered: items.length == 0,
            items: items
        }, () => {
            // restore scroll position after filtering
            setTimeout(() => {this.restoreScrollPosition()}, 50);
        });
    };

    private _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text?: string): void => {
        this.filterInputDebounced(text);
    };

    private _getSelectionDetails() {
        const total = this._allItems?.length ?? 0;
        const count = this._selection?.getSelectedCount() ?? 0;

        return (
            <div className={styles.selectionWrapper}>
                <div className={styles.metricBlock}>
                    <span className={styles.metricNumber}>{count}</span>
                    <span className={styles.metricLabel}>selected</span>
                </div>
                <div className={styles.metricDivider} />
                <div className={styles.metricBlock}>
                    <span className={styles.metricNumberSecondary}>{total}</span>
                    <span className={styles.metricLabel}>total</span>
                </div>
            </div>
        );
    }

    // 📅 Date-range filter persistence via URL params.
    // URL key = column field_key, value = `yyyyMMddHHmm-yyyyMMddHHmm` (floor-ceiling).
    private _formatDateFilterPart = (d: any): string => {
        const p2 = (n: number) => String(n ?? 0).padStart(2, "0");
        return `${String(d.year ?? 0).padStart(4, "0")}${p2(d.month)}${p2(d.day)}${p2(d.hour)}${p2(d.minute)}`;
    };

    private _parseDateFilterPart = (s: string): CalendarDateTime | null => {
        if (!/^\d{12}$/.test(s)) return null;
        try {
            return new CalendarDateTime(
                parseInt(s.slice(0, 4), 10),
                parseInt(s.slice(4, 6), 10),
                parseInt(s.slice(6, 8), 10),
                parseInt(s.slice(8, 10), 10),
                parseInt(s.slice(10, 12), 10)
            );
        } catch {
            return null;
        }
    };

    // We use hash routing (createHashRouter), so our filter params must live
    // INSIDE the hash (after the route path), e.g. `#/co/grp/library?kgnf_date=...`.
    // This keeps them attached through navigation and avoids touching the pre-hash
    // `?search` query that other parts of the app rely on.
    private _splitHash = (): { path: string; params: URLSearchParams } => {
        const hash = window.location.hash || "";
        const body = hash.startsWith("#") ? hash.slice(1) : hash;
        const qIdx = body.indexOf("?");
        const path = qIdx === -1 ? body : body.slice(0, qIdx);
        const params = new URLSearchParams(qIdx === -1 ? "" : body.slice(qIdx + 1));
        return { path, params };
    };

    private _getHashParam = (key: string): string | null => this._splitHash().params.get(key);

    // Commit a hash-param mutation. Returns true if the URL actually changed.
    private _setHashParam = (key: string, value: string | null): boolean => {
        const { path, params } = this._splitHash();
        if (value === null) {
            if (!params.has(key)) return false;
            params.delete(key);
        } else {
            if (params.get(key) === value) return false; // unchanged
            params.set(key, value);
        }
        const qs = params.toString();
        const newHash = `#${path}${qs ? "?" + qs : ""}`;
        window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}${newHash}`);
        return true;
    };

    // Read the filter range for a column key from the current URL (if present).
    private _readDateFilterFromUrl = (columnKey: string): { start: CalendarDateTime; end: CalendarDateTime } | null => {
        const raw = this._getHashParam(columnKey);
        if (!raw) return null;
        const parts = raw.split("-");
        if (parts.length !== 2) return null;
        // URL stores day-level (8-digit) values, so pad back the hour+minute (last 4 digits)
        // to the 12-digit form the parser/component expects.
        const padTo12 = (s: string) => (s.length === 8 ? `${s}0000` : s);
        const start = this._parseDateFilterPart(padTo12(parts[0]));
        const end = this._parseDateFilterPart(padTo12(parts[1]));
        if (!start || !end) return null;
        return { start, end };
    };

    // Write the filter range to the URL only when both ends are present and the
    // resulting value differs from what is already in the URL.
    private _writeDateFilterToUrl = (columnKey: string, range: any): void => {
        if (!range?.start || !range?.end) return;

        // filter granularity is day-level, so drop the trailing hour+minute (last 4 digits)
        const startPart = this._formatDateFilterPart(range.start).slice(0, 8);
        const endPart = this._formatDateFilterPart(range.end).slice(0, 8);
        const value = `${startPart}-${endPart}`;
        if (this._setHashParam(columnKey, value)) this.forceUpdate();
    };

    private _clearDateFilterUrl = (columnKey: string): void => {
        this.setState({ dateFilterColumnKey: null });
        if (this._setHashParam(columnKey, null)) this.forceUpdate();
    };

    // 📅 Custom header for date columns: keeps the default header (name + sort arrow)
    // and appends a tiny filter icon that toggles a date-range picker callout.
    // NOTE: data pull / filtering logic is intentionally not wired yet (UI only).
    private _renderDateFilterHeader = (columnKey: string, displayName: string) =>
        (props?: IDetailsColumnProps, defaultRender?: (p?: IDetailsColumnProps) => JSX.Element | null) => {
            const hasRange = !!this._readDateFilterFromUrl(columnKey);
            return (
                <div className={styles.dateFilterHeaderWrap}>
                    {defaultRender ? defaultRender(props) : <span>{displayName}</span>}
                    <span
                        id={`dateFilter_${columnKey}`}
                        title="Filter by date range"
                        className={`${styles.dateFilterIcon} ${hasRange ? styles.dateFilterIconActive : ""}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setState(prev => ({dateFilterColumnKey: prev.dateFilterColumnKey === columnKey ? null : columnKey}));
                        }}
                    >
                        <FiFilter size={12} />
                    </span>
                </div>
            );
        };

    // 🧪 custom header for value-filterable columns: keeps default header + a filter icon toggling a value checklist
    private _renderValueFilterHeader = (columnKey: string, displayName: string) =>
        (props?: IDetailsColumnProps, defaultRender?: (p?: IDetailsColumnProps) => JSX.Element | null) => {
            const active = (this.state.valueFilters[columnKey]?.length || 0) > 0;
            return (
                <div className={styles.dateFilterHeaderWrap} title={`${displayName}`}>
                    <div className={styles.valueFilterHeaderTitle}>
                        {defaultRender ? defaultRender(props) : <span>{displayName}</span>}
                    </div>
                    <div
                        id={`valueFilter_${columnKey}`}
                        title="Filter by value"
                        className={`${styles.dateFilterIcon} ${active ? styles.dateFilterIconActive : ""}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setState(prev => ({ valueFilterColumnKey: prev.valueFilterColumnKey === columnKey ? null : columnKey }));
                        }}
                    >
                        <FiFilter size={12} />
                    </div>
                </div>
            );
        };

    private _onColumnClick = (ev: React.MouseEvent<HTMLElement> | null, column: IColumn): void => {
        const { columns, items } = this.state;
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
                this.setState({ announcedMessage: `${currColumn.name} is sorted ${currColumn.isSortedDescending ? "descending" : "ascending"}` });
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        // save sorting state to localStorage
        setLocalSortState(localStorageMainListSorting, this.props.selectedGroup.oid, {
            key: currColumn.key,
            fieldName: currColumn.fieldName,
            isSortedDescending: currColumn.isSortedDescending
        });

        let newItems;
        newItems = mainSort(items, currColumn);

        this.setState({
            columns: newColumns,
            items:   newItems
        }, () => {setTimeout(() => {
            this.restoreScrollPosition()}, 50)
        });
    };


    private topCheck = (sip: string, oVal: number, viewerUpload: number) => {
        return (sip !== '' && sip !== "FileSelect" && (oVal >= 2 || viewerUpload == 1))
    }

    // 🧩 columns + saved-views management popover body
    private renderColumnCallout = (orderedColumns: IColumn[]) => {
        const uid       = this.props.loggedInUser?.userId || '';
        const nameCols  = orderedColumns.filter(c => c.name && c.name.trim() !== '');
        const views     = this.state.listViews;

        return (
            <div className={styles.columnCalloutBody}>
                {/* ── saved views ── */}
                <div className={styles.columnCalloutTitle}>Views</div>
                {views.length === 0 && <div className={styles.viewEmptyHint}>No saved views yet</div>}
                {views.map(v => {
                    const isOwner     = v.userid === uid;
                    const isActive    = this.state.activeViewId === v.id;
                    const isDefault   = Array.isArray(v.defaultview) && v.defaultview.includes(uid);
                    const isEditing   = this.state.editingViewId === v.id;
                    return (
                        <div key={v.id} className={styles.viewRow + (isActive ? " " + styles.viewRowActive : "")}>
                            {isEditing ? (
                                <input
                                    className={styles.viewNameInput}
                                    value={this.state.editingViewName}
                                    autoFocus
                                    onChange={e => this.setState({ editingViewName: e.target.value })}
                                    onKeyDown={e => { if (e.key === "Enter") { this.updateView(v, { viewname: this.state.editingViewName.trim() || v.viewname || '' }); this.setState({ editingViewId: null }); } }}
                                />
                            ) : (
                                <span className={styles.viewName} title={v.viewname || ''} onClick={() => this.applyListView(v)}>
                                    {v.viewname || "Untitled"}
                                    {!!v.ispublic && <span className={styles.viewPublicTag}>public</span>}
                                </span>
                            )}
                            <div className={styles.viewRowActions}>
                                <TooltipHost content={isDefault ? "Default view — click to unset" : "Set as my default"}>
                                    <FiStar size={14} className={isDefault ? styles.viewStarOn : styles.viewStarOff} onClick={() => this.toggleDefaultView(v)} />
                                </TooltipHost>
                                {isOwner && !isEditing && (
                                    <>
                                        <TooltipHost content="Update view to current layout"><FiCheck size={14} className={styles.viewActIcon} onClick={() => this.updateView(v)} /></TooltipHost>
                                        <TooltipHost content="Rename"><FiEdit size={13} className={styles.viewActIcon} onClick={() => this.setState({ editingViewId: v.id, editingViewName: v.viewname || '' })} /></TooltipHost>
                                        <TooltipHost content="Delete view"><FiTrash2 size={13} className={styles.viewActIconDanger} onClick={() => this.deleteView(v)} /></TooltipHost>
                                    </>
                                )}
                                {isOwner && isEditing && (
                                    <TooltipHost content="Save name"><FiCheck size={14} className={styles.viewActIcon} onClick={() => { this.updateView(v, { viewname: this.state.editingViewName.trim() || v.viewname || '' }); this.setState({ editingViewId: null }); }} /></TooltipHost>
                                )}
                            </div>
                        </div>
                    );
                })}

                {/* ── save current layout as a new view ── */}
                <div className={styles.viewSaveRow}>
                    <input
                        className={styles.viewNameInput}
                        placeholder="New view name"
                        value={this.state.viewNameDraft}
                        onChange={e => this.setState({ viewNameDraft: e.target.value })}
                        onKeyDown={e => { if (e.key === "Enter") this.saveNewView(); }}
                    />
                    <TooltipHost content="Visible to everyone in this space">
                        <Checkbox
                            label="Public"
                            checked={this.state.viewIsPublicDraft}
                            onChange={(_e, checked) => this.setState({ viewIsPublicDraft: !!checked })}
                            className={styles.viewPublicCheckbox}
                        />
                    </TooltipHost>
                    <TooltipHost content="Save current columns as a new view">
                        <PrimaryButton className={styles.viewSaveBtn} onClick={this.saveNewView}>
                            <FiPlus size={14} /> Save
                        </PrimaryButton>
                    </TooltipHost>
                </div>

                {/* ── columns: toggle visibility + drag to reorder ── */}
                <div className={styles.columnCalloutTitle}>Columns</div>
                <div className={styles.colReorderHint}>Drag <RxDragHandleDots2 size={12} /> to reorder</div>
                {nameCols.map(col => {
                    const locked = noVisibilityChangeCols.includes(col.key);
                    return (
                        <div
                            key={col.key}
                            className={styles.colReorderRow + (this.state.dragColKey === col.key ? " " + styles.colReorderRowDragging : "")}
                            draggable
                            onDragStart={() => this.setState({ dragColKey: col.key })}
                            onDragOver={e => e.preventDefault()}
                            onDrop={() => { if (this.state.dragColKey) this.reorderColumn(this.state.dragColKey, col.key); this.setState({ dragColKey: null }); }}
                            onDragEnd={() => this.setState({ dragColKey: null })}
                        >
                            <span className={styles.colDragHandle} title="Drag to reorder"><RxDragHandleDots2 size={15} /></span>
                            <Checkbox
                                label={col.name}
                                title={`Name: ${col.name}, Key: ${col.key}`}
                                checked={!this.state.hiddenColumnKeys.includes(col.key)}
                                onChange={() => this.toggleColumnVisibility(col.key)}
                                className={styles.columnCalloutCheckbox}
                                disabled={locked}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    public render() {
        const { columns, isCompactMode, items: itemsRaw, selectionDetails, isModalSelection, announcedMessage, isModalOpen, pathSelectionString, itemSelectionString } = this.state;
        // Hide data-container items (doc_category === 'data') unless the user toggles them on.
        const itemsPreFilter = (this.state.showDataItems || ((this.props.selectedGroup.assistanttype != "ipa" && this.props.selectedGroup.assistanttype != "dpa") && this.props.selectedGroup.viewerscanupload != 1)) ? itemsRaw : itemsRaw.filter(i => i?.doc_category !== 'data');
        const items = this.applyValueFilters(itemsPreFilter);
        const hasActiveValueFilters = Object.values(this.state.valueFilters).some(v => v?.length > 0);
        const orderedColumns = this.applyColumnOrder(columns);
        const visibleColumns = orderedColumns.filter(col => !this.state.hiddenColumnKeys.includes(col.key));
        return (
            <Fabric>
                <div className={classNames.controlWrapper} id="#dLM">
                    {this.topCheck(this.props.selectedGroup.selectionId, this.props.getOFromListVal, this.props.selectedGroup.viewerscanupload) ? ( // fileselect exclusion is legacy
                        <div className={styles.spaceHead}>
                            <div className={styles.rightButtonsMock}></div>
                            <div className={styles.rightButtons}>
                                {/* upload */}
                                {(this.props.selectedGroup.permissionlevel > 1 || this.props.selectedGroup.viewerscanupload == 1) && (
                                    <div id="addButtonOpI" className={styles.commsOnly}>
                                        <div className={styles.labelA}>Add</div>
                                        <div className={styles.iIcons}>
                                            <div className={styles.uploadButsContainerSecond}>
                                                <div className={styles.subButsContW}>
                                                    {/* pdf - default */}
                                                    <div>
                                                        <TooltipHost content="Add Documents" directionalHint={DirectionalHint.topCenter}>
                                                            <AddURLs
                                                                className={styles.commandButtonLib}
                                                                updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                butName="PDF"
                                                                calloutLabelText="Upload PDFs from your Device"
                                                                cTy="pdf"
                                                                listRefreshRequest={this.props.listRefreshRequest}
                                                                selectedGroup={this.props.selectedGroup}
                                                                callOutVisibility={this.callOutVisibility}
                                                            />
                                                        </TooltipHost>
                                                    </div>
                                                    {/* Images - cTy is pdf but we specialize the file content with acceptStr */}
                                                    <div>
                                                        <TooltipHost content="Add Images" directionalHint={DirectionalHint.topCenter}>
                                                            <AddURLs
                                                                className={styles.commandButtonLib}
                                                                updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                butName="PDF"
                                                                calloutLabelText="Upload Images from your Device"
                                                                cTy="pdf"
                                                                listRefreshRequest={this.props.listRefreshRequest}
                                                                selectedGroup={this.props.selectedGroup}
                                                                callOutVisibility={this.callOutVisibility}
                                                                acceptStr="image/*"
                                                            />
                                                        </TooltipHost>
                                                    </div>
                                                    {/* Video Files */}
                                                    {this.props.selectedGroup.allowvideofiles == 1 && (
                                                        <TooltipHost content="Add Video Files" directionalHint={DirectionalHint.topCenter}>
                                                            <AddURLs
                                                                className={styles.commandButtonLib}
                                                                updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                butName="Video"
                                                                calloutLabelText="Upload Video Files from your Device"
                                                                cTy="vid"
                                                                listRefreshRequest={this.props.listRefreshRequest}
                                                                selectedGroup={this.props.selectedGroup}
                                                                callOutVisibility={this.callOutVisibility}
                                                            />
                                                        </TooltipHost>
                                                    )}
                                                    {/* YouTube */}
                                                    {this.props.selectedGroup.allowyoutube == 1 && (
                                                        <div>
                                                            <TooltipHost content="Add YouTube videos" directionalHint={DirectionalHint.topCenter}>
                                                                <AddURLs
                                                                    className={styles.commandButtonLib}
                                                                    updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                    butName="YouTube"
                                                                    calloutLabelText="Enter YouTube URL"
                                                                    cTy="youtube"
                                                                    listRefreshRequest={this.props.listRefreshRequest}
                                                                    selectedGroup={this.props.selectedGroup}
                                                                    callOutVisibility={this.callOutVisibility}
                                                                />
                                                            </TooltipHost>
                                                        </div>
                                                    )}
                                                    {/* Web */}
                                                    {this.props.selectedGroup.allowweb == 1 && (
                                                        <div>
                                                            <TooltipHost content="Add Web Pages" directionalHint={DirectionalHint.topCenter}>
                                                                <AddURLs
                                                                    className={styles.commandButtonLib}
                                                                    updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                    butName="Web"
                                                                    calloutLabelText="Enter Web URL"
                                                                    cTy="web"
                                                                    listRefreshRequest={this.props.listRefreshRequest}
                                                                    selectedGroup={this.props.selectedGroup}
                                                                    callOutVisibility={this.callOutVisibility}
                                                                />
                                                            </TooltipHost>
                                                        </div>
                                                    )}
                                                    {/* Record Audio */}
                                                    {this.props.selectedGroup.allowaudiodocentry == 1 && (
                                                        <div>
                                                            <TooltipHost content="Record Content" directionalHint={DirectionalHint.topCenter}>
                                                                <AddURLs
                                                                    className={styles.commandButtonLib}
                                                                    updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                    butName="Web"
                                                                    calloutLabelText="Record Audio"
                                                                    cTy="mic"
                                                                    listRefreshRequest={this.props.listRefreshRequest}
                                                                    selectedGroup={this.props.selectedGroup}
                                                                    callOutVisibility={this.callOutVisibility}
                                                                />
                                                            </TooltipHost>
                                                        </div>
                                                    )}
                                                    {/* Web Page Links Extractor */}
                                                    {this.props.selectedGroup.urllinkextraction == 1 && (
                                                        <div>
                                                            <TooltipHost content="Extract Page Links" directionalHint={DirectionalHint.topCenter}>
                                                                <AddURLs
                                                                    className={styles.commandButtonLib}
                                                                    updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                    butName="Links"
                                                                    calloutLabelText="Follow Links"
                                                                    cTy="map"
                                                                    listRefreshRequest={this.props.listRefreshRequest}
                                                                    selectedGroup={this.props.selectedGroup}
                                                                    callOutVisibility={this.callOutVisibility}
                                                                />
                                                            </TooltipHost>
                                                        </div>
                                                    )}
                                                    {/* WAV Files - cTy is pdf but we specialize the file content with acceptStr */}
                                                    {this.props.selectedGroup.allowaudiofiles == 1 && (
                                                        <TooltipHost content="Add Audio Files" directionalHint={DirectionalHint.topCenter}>
                                                            <AddURLs
                                                                className={styles.commandButtonLib}
                                                                updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                butName="PDF"
                                                                calloutLabelText="Upload Audio files from your Device"
                                                                cTy="pdf"
                                                                listRefreshRequest={this.props.listRefreshRequest}
                                                                selectedGroup={this.props.selectedGroup}
                                                                callOutVisibility={this.callOutVisibility}
                                                                acceptStr=".wav"
                                                            />
                                                        </TooltipHost>
                                                    )}
                                                    {this.props.selectedGroup.allowgroupconnect == 1 && (
                                                        <TooltipHost content="Add Video Files" directionalHint={DirectionalHint.topCenter}>
                                                            <AddURLs
                                                                className={styles.commandButtonLib}
                                                                updateCatsState={(newValue: string) => this.props.updateCatsState(newValue)}
                                                                butName="Sync"
                                                                calloutLabelText="Sync with another Assistant"
                                                                cTy="sync"
                                                                listRefreshRequest={this.props.listRefreshRequest}
                                                                selectedGroup={this.props.selectedGroup}
                                                                callOutVisibility={this.callOutVisibility}
                                                            />
                                                        </TooltipHost>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.hiddenRefs}>
                                            <div id={`calloutButton_pdf`} className={styles.hiddenRefElement}></div>
                                            <div id={`calloutButton_img`} className={styles.hiddenRefElement}></div>
                                            <div id={`calloutButton_youtube`} className={styles.hiddenRefElement}></div>
                                            <div id={`calloutButton_vid`} className={styles.hiddenRefElement}></div>
                                            <div id={`calloutButton_web`} className={styles.hiddenRefElement}></div>
                                            <div id={`calloutButton_mic`} className={styles.hiddenRefElement}></div>
                                            <div id={`calloutButton_map`} className={styles.hiddenRefElement}></div>
                                            <div id={`calloutButton_sync`} className={styles.hiddenRefElement}></div>
                                        </div>
                                    </div>
                                )}


                                {/* search button */}
                                <div className={styles.searchBoxDivWReload}>
                                    {/* search content list main */}
                                    <SrchBox onUpd={this._onChangeText} placeholder="Search..."/>
                                </div>

                                {/* refresh list button */}
                                <div
                                    className={styles.reloadBoxDiv}
                                    onClick={() => {
                                        this.props.listRefreshRequest()
                                        this.props.onDelFile();
                                        setTimeout(() => {toast.info("List Refreshing...", {autoClose: 500})}, 30);
                                    }}
                                >
                                    <TooltipHost content="Refresh List" directionalHint={DirectionalHint.topCenter}>
                                        <div className={styles.reloadBoxIcon}>
                                            <AiOutlineReload size={17} color="#fff" className={styles.reloadFiIcon} />
                                        </div>
                                    </TooltipHost>
                                </div>

                                {/* column visibility */}
                                <div
                                    id="columnVisibilityButton"
                                    className={styles.columnVisibilityButton}
                                    onClick={() => this.setState(prev => ({ isColumnCalloutVisible: !prev.isColumnCalloutVisible }))}
                                >
                                    <TooltipHost content="Show/Hide Columns" directionalHint={DirectionalHint.topCenter}>
                                        <div className={styles.reloadBoxIcon}>
                                            <BiColumns size={18} color="#fff" className={styles.reloadFiIcon} />
                                        </div>
                                    </TooltipHost>
                                </div>

                                {/* column visibility callout */}
                                {this.state.isColumnCalloutVisible && (
                                    <Callout
                                        role="dialog"
                                        gapSpace={4}
                                        styles={visibilityCalloutContentStyles}
                                        target="#columnVisibilityButton"
                                        onDismiss={() => this.setState({ isColumnCalloutVisible: false, editingViewId: null })}
                                        directionalHint={DirectionalHint.bottomCenter}
                                        setInitialFocus
                                    >
                                        {this.renderColumnCallout(orderedColumns)}
                                    </Callout>
                                )}

                                {/* 🧪 value filter callout — anchored to the active column header's filter icon */}
                                {this.state.valueFilterColumnKey && (
                                    <Callout
                                        role="dialog"
                                        gapSpace={4}
                                        target={`#valueFilter_${this.state.valueFilterColumnKey}`}
                                        onDismiss={() => this.setState({ valueFilterColumnKey: null })}
                                        directionalHint={DirectionalHint.bottomRightEdge}
                                        setInitialFocus
                                    >
                                        <div className={styles.valueFilterBody}>
                                            <div className={styles.valueFilterHeader}>
                                                <span className={styles.columnCalloutTitle}>Filter</span>
                                                {(this.state.valueFilters[this.state.valueFilterColumnKey]?.length || 0) > 0 && (
                                                    <span className={styles.valueFilterClear} onClick={() => this.clearValueFilter(this.state.valueFilterColumnKey!)}>Clear</span>
                                                )}
                                            </div>
                                            {this.getDistinctColumnValues(this.state.valueFilterColumnKey).map(v => (
                                                <Checkbox
                                                    key={v.raw}
                                                    label={`${v.label} (${v.count})`}
                                                    checked={(this.state.valueFilters[this.state.valueFilterColumnKey!] || []).includes(v.raw)}
                                                    onChange={() => this.toggleValueFilter(this.state.valueFilterColumnKey!, v.raw)}
                                                    className={styles.columnCalloutCheckbox}
                                                />
                                            ))}
                                        </div>
                                    </Callout>
                                )}

                                {/* invoice assistant csv download */}
                                {(this.props.selectedGroup.assistanttype == "ipa" || this.props.selectedGroup.assistanttype == "bpa" || this.props.selectedGroup.assistanttype == "dpa") && this.props.selectedGroup.viewerscanupload != 1 && (
                                    <>
                                        {/* toggle data items visibility */}
                                        {this.state.itemsCount.dataFiles > 0 && this.props.selectedGroup.assistanttype != "bpa" && (
                                            <TooltipHost content={this.state.showDataItems ? "Hide data items" : "Show data items"} directionalHint={DirectionalHint.topCenter}>
                                                <div className={styles.dataToggleButton} onClick={() => this.setState(prev => ({ showDataItems: !prev.showDataItems }))}>
                                                    <FiDatabase size={18} color={this.state.showDataItems ? "#30b27e" : "#2f4858"} />
                                                </div>
                                            </TooltipHost>
                                        )}
                                        {(this.props.selectedGroup.assistanttype == "ipa" || this.props.selectedGroup.assistanttype == "bpa") && (
                                            <TooltipHost content="Download CSV of all Structured Data" directionalHint={DirectionalHint.rightTopEdge}>
                                                <div className={styles.exportCsvButton} onClick={() => exportCSV(this.props.selectedGroup?.oid?.toString(), getHeader(this.props.loggedInUser))}>
                                                    <TbTableDown size={18} color="#2f4858" />
                                                </div>
                                            </TooltipHost>
                                        )}
                                        {this.props.selectedGroup.assistanttype == "dpa" && (
                                            <TooltipHost content="Download CSV of all Structured Data" directionalHint={DirectionalHint.rightTopEdge}>
                                                <div className={styles.exportCsvButton} onClick={this._exportDpaInvDataCsv}>
                                                    <TbTableDown size={18} color="#2f4858" />
                                                </div>
                                            </TooltipHost>
                                        )}
                                    </>
                                )}

                                {/* universal content csv download - tbi */}
                                {this.props.selectedGroup.assistanttype == "dpa" && this.props.selectedGroup?.contenttype_config?.postaianalysisoptions?.preconfopt == "2" && (
                                    <TooltipHost content="Download CSV of all Structured Data" directionalHint={DirectionalHint.rightTopEdge}>
                                        <div className={styles.exportCsvButton} onClick={() => exportAIExtractPredef(this.props.selectedGroup?.selectionId?.toString(), getHeader(this.props.loggedInUser))}>
                                            <TbTableDown size={18} color="#2f4858" />
                                        </div>
                                    </TooltipHost>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className={styles.spaceHead}>
                            <span className={styles.rightButtonsMock}>{}</span>
                            <div className={styles.rightButtons}>
                                <div className={styles.searchBoxNoUpl}>
                                    <SrchBox onUpd={this._onChangeText} placeholder="Search..."/>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* 📋 sidebar lists - data items flagged dash_list = 1 */}
                {this.isDashListGroup_dash() && (
                    <DashListSidebar_dash
                        fileList={this.props.fileList}
                        selectedGroup={this.props.selectedGroup}
                        loggedInUser={this.props.loggedInUser}
                        onOpenFull={(file, data) => {
                            const doc = this.state.items.find(i => String(i.fileid) === String(file.fileid)) || this._allItems.find(i => String(i.fileid) === String(file.fileid));
                            if (!doc) return;
                            if (data !== undefined) this.setState({ dataListModalItem: { ...doc, invoicedata: data } });
                            else this.handleDocumentDisplay(doc);
                        }}
                        onRemove={file => this.qSetDashList_dash(file.fileid, 0)}
                    />
                )}

                {/* content / full-page loading / upload cards / shimmer list */}
                {((items?.length > 0 && this._allItems?.length > 0) || (this.state.isZeroFiltered == true) || (hasActiveValueFilters && this._allItems?.length > 0)) ? (

                    // items more then zero ⇒ full page loading spinner and item list
                    <div className={styles.listHeightWrapper}  style={{ overflow: this.state.isLoading ? "hidden" : "auto" }}>

                        <ThemeProvider theme={detailsListTheme}>
                            {this.state.isLoading == true && (
                                <div className={styles.loadingOverlayContainerDetList}>
                                    <div className={styles.loadingOverlayDetList}>
                                        <div className={styles.typingDotsDetList}>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <MarqueeSelection selection={this._selection} >
                                <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto} styles={(window.innerWidth > 649) ? scrollablePaneStyles : scrollablePaneShortStyles} >
                                    <DetailsList
                                        className={styles.customDetailsList}
                                        items={items}
                                        compact={isCompactMode}
                                        columns={visibleColumns}
                                        isHeaderVisible={true}
                                        selectionMode={SelectionMode.multiple}
                                        setKey="multiple"
                                        layoutMode={DetailsListLayoutMode.justified}
                                        selection={this._selection}
                                        selectionPreservedOnEmptyClick={true}
                                        onItemInvoked={this.handleDocumentDisplay}
                                        enterModalSelectionOnTouch={true}
                                        ariaLabelForSelectionColumn="Toggle Selection"
                                        ariaLabelForSelectAllCheckbox="Toggle Selection for all items"
                                        checkButtonAriaLabel="Row Checkbox"
                                        onItemContextMenu={this.onItemContextMenu}
                                        styles={controlDetailsListMainStyles}
                                        onRenderDetailsHeader={(props?: IDetailsHeaderProps) => onRenderDetailsHeaderV2(props!)}
                                        onRenderRow={(prps: IDetailsRowProps | undefined): JSX.Element => {
                                            return <DetailsRow {...(prps as IDetailsRowProps)} styles={prps?.styles} />;
                                        }}
                                        onShouldVirtualize={() => items.length > 200}
                                        listProps={{
                                            renderedWindowsAhead: 6
                                        }}

                                    />
                                </ScrollablePane>
                            </MarqueeSelection>
                        </ThemeProvider>
                    </div>
                ) : this.props.fileList == undefined ? (

                    // no items at all ⇒ show upload cards
                    <div className={styles.greetingsDetList}>
                        <ShimmeredDetailsList
                            className={styles.customDetailsListShimmer}
                            enableShimmer={true}
                            items={[]}
                            shimmerLines={7}
                            columns={columns}
                            compact={false}
                            selectionMode={SelectionMode.none}
                            layoutMode={DetailsListLayoutMode.justified}
                            isHeaderVisible={false}
                            selectionPreservedOnEmptyClick={true}
                            enterModalSelectionOnTouch={true}
                        />
                        <div className={styles.noDocsUploadCardsContainerAbs}>
                            {(this.props.selectedGroup.permissionlevel >= 2 || this.props.selectedGroup.viewerscanupload == 1) && (
                                <UploadCards
                                    onUploadCardClick={onUploadCardClick}
                                    selectedGroup={this.props.selectedGroup}
                                />
                            )}

                        </div>
                    </div>
                ) : (
                    // loading ⇒ show shimmer list
                    <>
                        <div className={styles.typingDotsZIndex}>
                            <div className={styles.typingDotsDetList}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>

                        </div>
                        <ShimmeredDetailsList
                            className={styles.customDetailsListShim}
                            enableShimmer={true}
                            items={[]}
                            shimmerLines={3}
                            columns={columns}
                            compact={isCompactMode}
                            selectionMode={SelectionMode.multiple}
                            setKey="multiple"
                            layoutMode={DetailsListLayoutMode.justified}
                            isHeaderVisible={true}
                            enableUpdateAnimations={true}
                            selection={this._selection}
                            selectionPreservedOnEmptyClick={true}
                            onItemInvoked={this.handleDocumentDisplay}
                            enterModalSelectionOnTouch={true}
                            ariaLabelForSelectionColumn="Toggle selection"
                            onRenderDetailsHeader={(props?: IDetailsHeaderProps) => onRenderDetailsHeader(props!)}
                        />
                    </>

                )}

                {/* selection details text - bottom left */}
                {this.state.selectionDetails && (
                    <div className={styles.selDet}>
                        <div className={styles.selectionDetailsWrap}>
                            {this.state.selectionDetails}
                        </div>
                        {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                            <div className={styles.contactUs} >
                                <TooltipHost content={helpMailTooltip} styles={tooltipHostStyles} directionalHint={DirectionalHint.topCenter}>
                                    <a href="mailto:hey@kgnfy.com">
                                        <div className={styles.contactIcon}>
                                            <LuMailQuestion size={22} color="#FFA239" />
                                        </div>
                                    </a>
                                </TooltipHost>
                            </div>
                        )}
                    </div>
                )}

                {/* context menu */}
                {this.state.isContextMenuVisible && (
                    <ContextualMenu
                        styles={listContextMenuStyles}
                        items={[
                            { key: "Download", text: "Download", onClick: this.onContextMenuItemClick, disabled: false},
                            { key: "CopyValue", text: "Copy Value/s", onClick: this.onContextMenuItemClick, disabled: false },
                            ...(this.props.selectedGroup.permissionlevel >= 2
                                ? [
                                    { key: "Reindex", text: "Reprocess", onClick: this.onContextMenuItemClick, disabled: false },
                                    { key: "Share", text: "Move", onClick: this.onContextMenuItemClick, disabled: isItemReady(this.state.targetItem) == false }]
                                : []),
                            ...(this.props.selectedGroup.assistanttype == "cmp" && this.props.selectedGroup.permissionlevel >= 2
                                ? [{ key: "Diff", text: "Compare", onClick: this.onContextMenuItemClick }]
                                : []),
                            ...(this.props.selectedGroup.assistanttype == "dpa" && this.props.selectedGroup.permissionlevel >= 1
                                ? [{ key: "Analyse", text: "Analyse", onClick: this.onContextMenuItemClick }]
                                : []),
                            ...(this.isDashListGroup_dash() && this.props.selectedGroup.permissionlevel >= 2 && this.state.targetItem?.doc_category == "data"
                                ? [{ key: "DashList", text: this.state.targetItem?.dash_list == 1 ? "Remove from Sidebar Lists" : "Show as Sidebar List", onClick: this.onContextMenuItemClick, disabled: isItemReady(this.state.targetItem) == false }]
                                : []),
                            ...(this.props.selectedGroup.assistanttype == assistantCodes.ipa && this.props.selectedGroup.permissionlevel >= 1
                                ? [{ key: "Versions", text: "Versions", onClick: this.onContextMenuItemClick, disabled: isItemReady(this.state.targetItem) == false }]
                                : []),
                            ...(this.props.selectedGroup.assistanttype == "dpa" && this.props.selectedGroup.permissionlevel >= 1 && this.props.selectedGroup?.contenttype_config?.postaianalysisoptions?.preconfopt == "2"
                                ? [{ key: "RerunPreconfAnalysis", text: "Rerun Preconfigured Analysis", onClick: this.onContextMenuItemClick }]
                                : []),
                            ...((this.props.selectedGroup.assistanttype == "dpa" || this.props.selectedGroup.assistanttype == "cca" || this.props.selectedGroup.assistanttype == "pps") && this.props.selectedGroup.permissionlevel >= 2
                                ? [{ key: "IndexView", text: "View AI Meta", onClick: this.onContextMenuItemClick, disabled: isItemReady(this.state.targetItem) == false }]
                                : []) ,
                            ...((this.props.selectedGroup.permissionlevel >= 2) || (this.props.selectedGroup.viewerscanupload == 1)
                                ? [{ key: "Delete", text: "Delete", onClick: this.onContextMenuItemClick, itemProps: {styles: { root: {color: "#8B0000", backgroundColor: "#FFCCCB"}}}}]
                                : [])
                        ]}
                        target={this.state.contextMenuTarget}
                        onDismiss={() => this.setState({ isContextMenuVisible: false })}
                    />
                )}

                {/* space filter ? */}
                {this.state.isSpaceFilterVisible && (
                    <ContextualMenu
                        items={this.getSpaceFilterChoices()}
                        target={document.getElementById("spaceHeaderFilterIcon")}
                        onDismiss={() => this.setState({ isSpaceFilterVisible: false })}
                    />
                )}

                {/* share modal */}
                <Modal
                    isOpen={this.state.isSecurityModalOpen}
                    onDismiss={this.hideSecurityModal}
                    isBlocking={false}
                    containerClassName={styles.changeSpaceModalMain}
                >
                    <div style={{ margin: "20px" }}>
                        <div className={styles.changeSpaceTextPortion}>
                            <div className={styles.changeSpaceHTitle}>Move</div>
                            <div className={styles.changeSpaceHDetails}>Change the Space for the Selected Item</div>
                        </div>
                        <div className={styles.changeSpaceHDropdownContained}>
                            <Select
                                options={this.props.groupList
                                    .filter((option: any) => option.key !== "FileSelect" && option.memberlevel >= 2 && option.key !== this.props.selectedGroup.selectionId)
                                    .map((option: any) => ({ value: option.key, label: option.text }))}
                                onChange={(selectedOption: any) => {
                                    if (selectedOption) this.qHandleFileSelectionSpaceChange(selectedOption.value, selectedOption.label);
                                }}
                                placeholder="Select an Assistant..."
                                styles={{
                                    menu: provided => ({
                                        ...provided,
                                        maxHeight: 400
                                    }),
                                    control: provided => ({
                                        ...provided,
                                        maxHeight: 50 // Height of the control bar (adjust as needed)
                                    })
                                }}
                                menuPlacement="auto"
                                menuPosition="fixed"
                            />
                        </div>
                    </div>
                </Modal>

                {/* json grid */}
                <Modal
                    isOpen={this.state.invoiceModalItem == undefined ? false : true}
                    onDismiss={this.hideInvoiceModal}
                    isBlocking={false}
                    containerClassName={styles.invoiceModalWrap}
                >
                    <JsonGridInvoice
                        fileid={this.state.invoiceModalItem?.fileid?.toString() || ""}
                        filename={this.state.invoiceModalItem?.name || ""}
                        invdata={this.state.invoiceModalItem?.invoicedata}
                        loggedInUser={this.props.loggedInUser}
                    />
                </Modal>

                {/* full-screen data list (csv/json) view-only table */}
                <Modal
                    isOpen={this.state.dataListModalItem == undefined ? false : true}
                    onDismiss={() => this.setState({ dataListModalItem: undefined })}
                    isBlocking={false}
                    containerClassName={styles.dataListModalContainer}
                >
                    <div className={styles.dataListModalHeader}>
                        <div className={styles.dataListModalTitle} title={this.state.dataListModalItem?.name}>
                            {this.state.dataListModalItem?.name}
                        </div>
                        <div className={styles.dataListModalClose} title="Close" onClick={() => this.setState({ dataListModalItem: undefined })}>
                            <FaWindowClose size={35} />
                        </div>
                    </div>
                    <div className={styles.dataListModalBody}>
                        <JsonListTable
                            data={this.state.dataListModalItem?.invoicedata}
                            title={this.state.dataListModalItem?.name}
                            fid={this.state.dataListModalItem?.fileid?.toString() || ""}
                            ext_stamp={this.state.dataListModalItem?.ext_stamp || new Date(0)}
                        />
                    </div>

                </Modal>

                {/* 🕰️ versions modal — lists previous invoicedata versions for a file */}
                <Modal
                    isOpen={this.state.versionsModalItem == undefined ? false : true}
                    onDismiss={this.hideVersionsModal}
                    isBlocking={false}
                    containerClassName={styles.versionsModalContainer}
                >
                    <div className={styles.versionsModalHeader}>
                        <div className={styles.versionsModalTitle} title={this.state.versionsModalItem?.name}>
                            Versions — {this.state.versionsModalItem?.name}
                        </div>
                        <div className={styles.versionsModalClose} title="Close" onClick={this.hideVersionsModal}>
                            <FaWindowClose size={28} />
                        </div>
                    </div>
                    <div className={styles.versionsModalBody}>
                        {this.state.isVersionsLoading ? (
                            <div className={styles.versionsModalEmpty}>Loading…</div>
                        ) : this.state.versionsList.length === 0 ? (
                            <div className={styles.versionsModalEmpty}>No previous versions available.</div>
                        ) : (
                            <DetailsList
                                items={this.state.versionsList}
                                selectionMode={SelectionMode.none}
                                layoutMode={DetailsListLayoutMode.justified}
                                isHeaderVisible={true}
                                onActiveItemChanged={(item?: any) => { if (item) this.handleVersionSelect(item as gversionrow); }}
                                onRenderRow={(props, defaultRender) => {
                                    if (!props || !defaultRender) return null;
                                    const v = props.item as gversionrow;
                                    return (
                                        <div className={v.isLatest ? styles.versionRowLatest : styles.versionRowClickable}>
                                            {defaultRender(props)}
                                        </div>
                                    );
                                }}
                                columns={[
                                    {
                                        key: "stamp",
                                        name: "Date",
                                        fieldName: "stamp",
                                        minWidth: 150,
                                        maxWidth: 220,
                                        isResizable: true,
                                        onRender: (v: gversionrow) => (
                                            <span>
                                                {v.stamp ? getDateToDisplay(new Date(v.stamp)) : ""}
                                                {v.isLatest && <span className={styles.versionCurrentBadge}>Current</span>}
                                            </span>
                                        )
                                    },
                                    {
                                        key: "upd_type",
                                        name: "Update Type",
                                        fieldName: "upd_type",
                                        minWidth: 110,
                                        maxWidth: 200,
                                        isResizable: true,
                                        onRender: (v: gversionrow) => (
                                            <span>{removeUnderscoreAndCapitalize(v.upd_type || "—")}</span>
                                        )
                                    },
                                    {
                                        key: "file",
                                        name: "File",
                                        fieldName: "linkedFile",
                                        minWidth: 140,
                                        maxWidth: 320,
                                        isResizable: true,
                                        onRender: (v: gversionrow) => (
                                            v.linkedFile && v.linkedFile.blobpath ? (
                                                <span
                                                    className={styles.versionFileLink}
                                                    title={`Download ${v.linkedFile.filename}`}
                                                    onMouseDown={(e) => { e.stopPropagation(); this.versionFileClickGuard = true; }}
                                                    onClick={(e) => { e.stopPropagation(); this.versionFileClickGuard = false; this.handleVersionFileDownload(v); }}
                                                >
                                                    <FiDownload size={14} />
                                                    <span className={styles.versionFileLinkText}>{v.linkedFile.filename}</span>
                                                </span>
                                            ) : (
                                                <span className={styles.versionFileNone}>—</span>
                                            )
                                        )
                                    }
                                ]}
                            />
                        )}
                    </div>
                </Modal>

                {/* ai search json grid */}
                <Modal
                    isOpen={this.state.aiSearchData == undefined ? false : true}
                    onDismiss={this.hideAISearchDataModal}
                    isBlocking={false}
                    containerClassName={styles.aiSearchRIndicesModal}
                >
                    <div className={styles.indicesModalTitle}>{this.state.activeFile?.name}</div>
                    <AISearchJsonGrid value={this.state.aiSearchData?.indx_results} itmTitle={this.state.invoiceModalItem?.name} />
                </Modal>

                {/* invoice modal */}
                <Modal
                    isOpen={this.state.summaryModalItem == undefined ? false : true}
                    onDismiss={this.hideSummaryModal}
                    isBlocking={false}
                    containerClassName={styles.invoiceModal}
                >
                    <CollapsibleSections data={this.state.summaryModalItem || []} />
                </Modal>

                {/* convo rec modal */}
                <Modal
                    isOpen={this.state.isMicModalVisible}
                    onDismiss={() => this.isMicModalVisible()}
                    isBlocking={false}
                    containerClassName={styles.convoRecModalContainer}
                >
                    <ConversationRecognizer
                        selectedGroup={this.props.selectedGroup}
                        loggedInUser={this.props.loggedInUser}
                        publishTranscriptDraftCallback={(transcriptObject: gtranscriptpublish) =>
                            this.publishTranscriptDraftHandler(transcriptObject, this.props.listRefreshRequest)
                        }
                        activeFile={this.state.activeFile}
                        onSTT={onSTT}
                        rndo={Math.random().toString(36).substring(2, 6)}
                    />
                </Modal>

                {/* analysis creation options modal */}
                <Modal
                    isOpen={this.state.isAnalysisOptionsVisible}
                    onDismiss={() => this.setState({ isAnalysisOptionsVisible: false })}
                    isBlocking={false}
                    containerClassName={styles.analysisOptionsModalContainer}
                    styles={modalAIAnalysisStyles}
                    closeButtonAriaLabel="Close"
                >
                    <div className={styles.analysisTitle}>Content Analysis</div>
                    <div className={styles.analysisInfoText}>
                        Define what you want to know about the selected content.
                    </div>
                    <IconButton
                        onClick={() => this.setState({ isAnalysisOptionsVisible: false })}
                        title="Close"
                        styles={analysisOptionsStyles}
                        className={styles.closeButICAnalysisOptions}
                    >
                        <FaWindowClose size={36} />
                    </IconButton>
                    <TextField
                        className={styles.spaceTextFields}
                        styles={textFieldStylesMultiAIAnalyseOpt}
                        label="Instructions"
                        multiline
                        resizable={false}
                        autoAdjustHeight
                        value={this.state.aioptions.instructions}
                        onChange={(_, newValue) => this.setState({ aioptions: { ...this.state.aioptions, instructions: newValue || "" } })}
                    />
                    <div className={styles.submitAIAnalysisButtonWrap}>
                        <PrimaryButton
                            text="Submit"
                            onClick={() => {
                                this.setState({ isAnalysisOptionsVisible: false });
                                this.handleAnalyseButtonClick(this.state.aioptionsselected, false);
                            }}
                            disabled={false}
                            className={styles.submitAIAnalysisRequestButton}
                        />
                    </div>

                </Modal>

                {/* analysis modal */}
                <Modal
                    isOpen={this.state.isAnalysisModalVisible}
                    onDismiss={() => this.setState({ isAnalysisModalVisible: false })}
                    isBlocking={false}
                    containerClassName={styles.analysisModalContainer}
                    closeButtonAriaLabel="Close"
                    allowTouchBodyScroll={true}
                >
                    {/* close button */}
                    <div className={styles.analysisModalContainerInnerWrap} id="kgnfanalysiscontent">
                        <IconButton
                            onClick={() => this.setState({ isAnalysisModalVisible: false })}
                            title="Close"
                            styles={analysisCloseButStyles}
                            className={styles.closeButICAnalysisMain}
                        >
                            <FaWindowClose size={36} />
                        </IconButton>


                        {/*  TBI Case */}
                        {this.state.isAnalysisModalVisible == true && this.state?.analysisContent?.result && this.state?.analysisContent?.result?.description ? (
                            <>                        {/* remove button */}
                                <div className={styles.analysisContentPredefMD}>
                                    <div className={styles.analysisTopTop}>
                                        <div className={styles.analysisTitlePredef}>{this.state?.activeFile?.name}</div>
                                    </div>
                                    <div className={styles.analysisSubtitlePredef}>
                                        {dpaAnalysisOptionsDisplayNames.get(
                                            (this.props.selectedGroup?.contenttype_config?.postaianalysisoptions?.preconfopt || "1").toString()
                                        )}
                                    </div>

                                    <table className={styles.analysisTable} style={{ borderCollapse: "collapse", width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th style={thStylesDetList1} className={styles.analysisTableHeaderPredef}>Field</th>
                                                <th style={thStylesDetList1} className={styles.analysisTableHeaderPredef}>Value</th>
                                                <th style={thStylesDetList1} className={styles.analysisTableHeaderPredef}>Source</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dpaAnalysisOpt2Keys.map((key: string, index: number) => (
                                                <tr key={index}>
                                                    <td style={thStylesDetList2}>{removeUnderscoreAndCapitalize(key)}</td>
                                                    <td style={thStylesDetList2}>{this.state?.analysisContent?.result[key]}</td>
                                                    <td style={thStylesDetList2}>
                                                        {this.state?.analysisContent?.result[`${key}_source`] ||
                                                            this.state?.analysisContent?.result[`source_text_for_${key}`]}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className={styles.footeraiinteractioncallout}>{this.state.aiinteractionid}</div>
                                </div>
                            </>


                        ) : this.state.isAnalysisModalVisible == true && this.state?.analysisContent?.result && typeof this.state?.analysisContent?.result === 'string' ? (
                            <>
                                <IconButton
                                    onClick={() => {this.removeaiinteraction(this.state.aiinteractionid)}}
                                    title="Remove"
                                    styles={analysisRemoveButStyles}
                                    className={styles.removeButICAnalysisMain}
                                >
                                    <ImBin size={16} />
                                </IconButton>
                                <div>
                                    <div className={styles.analysisTopTop}>
                                        <div className={styles.analysisTitle}>Analysis</div>
                                    </div>

                                    <div
                                        className={styles.analysisContentMD}
                                        id="analysisContentMDOne"
                                        style={{ zIndex: 1001111 }}
                                        dangerouslySetInnerHTML={{__html: prepHtml(this.state?.analysisContent)}}
                                    />
                                </div>
                            </>
                        ) : this.state.isAnalysisModalVisible == true && this.state?.analysisContent?.result && typeof this.state?.analysisContent?.result != 'string' && this.props.selectedGroup?.contenttype_config?.postaianalysisoptions?.preconfopt == "3" ? (
                            <>
                                {/** Custom definition for 1-Content-Type DPA Config */}
                                <div className={styles.analysisContUni}>
                                    {/* custom definition dpa view 03 */}
                                    <div className={styles.analysisTitleUni}>
                                        {dpaAnalysisOptionsDisplayNames.get((this.props.selectedGroup?.contenttype_config?.postaianalysisoptions?.preconfopt || '1').toString())}
                                    </div>
                                    <div className={styles.analysisUniWrap}>
                                        <div className={styles.analysisContentMD} id="analysisContentMDThree">
                                            {/*<JsonGridGenBasic jsonString={JSON.stringify(this.state?.analysisContent?.result)}/>*/}
                                            <JsonViewerInteractive
                                                jsonString={JSON.stringify(this.state?.analysisContent?.result)}
                                                title="Extracted Data"  // optional, defaults to "Data"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : this.props.selectedGroup?.contenttype_config?.postaianalysisoptions?.preconfopt  == "4" ? (
                            <>
                                {/** Custom definition for Multi-Content-Type DPA Config */}
                                <div className={styles.analysisContUni}>
                                    {/* custom definition dpa view */}
                                    <div className={styles.analysisTitleUni}>
                                        {dpaAnalysisOptionsDisplayNames.get((this.props.selectedGroup?.contenttype_config?.postaianalysisoptions?.preconfopt || '1').toString())}
                                    </div>
                                    <div className={styles.analysisUniWrap}>
                                        <div className={styles.analysisContentMD} id="analysisContentMDFour">
                                            <JsonViewerInteractive
                                                jsonString={JSON.stringify(this.state?.analysisContent?.result)}
                                                title="Post Analysis Results"
                                                aiid={this.state.aiinteractionid}
                                                fieldorder={this.state.aiifieldorder}
                                                onFieldOrderChange={(order, aiid) => {
                                                    this.setState({ aiifieldorder: order });
                                                    qUpdateFieldOrder(aiid, order, this.props.loggedInUser);
                                                }}
                                                onApplyFieldOrderToDocType={this.state.analysisDocCategory ? (fieldorder) => {
                                                    qApplyFieldOrderByDocType(
                                                        this.props.selectedGroup.selectionId,
                                                        this.state.analysisDocCategory,
                                                        fieldorder,
                                                        this.props.loggedInUser
                                                    ).then(ok => {
                                                        if (ok) toast.success("Field order applied to all items with same type", { autoClose: 2000 });
                                                        else toast.error("Failed to apply field order");
                                                    });
                                                } : undefined}
                                                sgp={this.props.selectedGroup}
                                                editable={this.props.selectedGroup?.contenttype_config?.allow_human_result_edits == 1}
                                                onContentChange={(data, aiid) => {
                                                    qUpdateAiContent(aiid, data, this.props.loggedInUser).then(ok => {
                                                        if (ok) toast.success("Content updated", { autoClose: 1500 });
                                                        else toast.error("Failed to update content");
                                                    });
                                                }}
                                            />
                                        </div>
                                        {this.props.selectedGroup?.contenttype_config?.show_base_extract_in_preview == 1 && (() => {
                                            const selItem = this._selection.getSelection()[0] as IDocument | undefined;
                                            const baseData = selItem?.invoicedataobj;

                                            const item = (this.getActiveFile(this._selection.getSelection()))
                                            const fid = item?.fileid ?? selItem?.key;
                                            // const fname = item?.name ?? selItem?.name;
                                            if (!fid || !baseData || Object.keys(baseData).length == 0) return null;
                                            return (
                                            <div className={styles.analysisContentMD} id="analysisContentMDFourBase">
                                                {/* base extraction of the selected item; aiid carries the fid so JsonViewerInteractive fires onContentChange */}
                                                <JsonViewerInteractive
                                                    jsonString={JSON.stringify(baseData)}
                                                    title="Base Extraction"
                                                    aiid={fid}
                                                    sgp={this.props.selectedGroup}
                                                    editable={this.props.selectedGroup?.contenttype_config?.allow_human_result_edits == 1}
                                                    onContentChange={(data, fid) => {
                                                        const newBase = rewrapUcpData(baseData, data);
                                                        qUpdateBaseContent(this.props.loggedInUser, this.props.selectedGroup.selectionId, fid, newBase).then(ok => {
                                                            if (ok) {
                                                                toast.success("Content updated", { autoClose: 1500 });
                                                                this.props.listRefreshRequest(fid);
                                                            } else toast.error("Failed to update content");
                                                        });
                                                    }}
                                                />
                                            </div>
                                            );
                                        })()}
                                    </div>

                                </div>
                            </>
                        ) :  (
                            <div className={styles.analysisTitle}>Loading...</div>
                        )}

                        {this.state.isAnalysisModalVisible == true && this.state?.analysisContent?.chartjs_jsons?.map((chart: any, index: number) => {
                            return (
                                <div key={index} className={styles.analysisChartsMD}>
                                    <ChartRendererAnalysis configChart={chart} />
                                </div>
                            );
                        })}
                    </div>
                </Modal>
            </Fabric>
        );
    }
}

